import React, { createContext, useContext, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetch4, fetch5 } from "../commonApis/commonApis";
import { addProfileData } from "../features/auth/authSlice";

const LOCAL_DICTIONARY: Record<string, string> = {
  // SMS, Delete, Forward, Label Print & Reverse Modals
  "sms": "رسالة نصية",
  "picklist": "قائمة الالتقاط",
  "pick list": "قائمة الالتقاط",
  "send": "إرسال",
  "mobile no": "رقم الجوال",
  "mobile no.": "رقم الجوال",
  "send mobile number": "رقم الجوال",
  "message": "الرسالة",
  "forwarded 3pl company": "شركة شحن خارجية (3PL) المحولة",
  "3pl company is required": "شركة شحن خارجية (3PL) مطلوبة",
  "no of pieces is required": "عدد القطع مطلوب",
  "select 3pl company": "اختر شركة شحن خارجية (3PL)",
  "label print": "طباعة الملصق",
  "default label print": "طباعة الملصق الافتراضية",
  "switch to default": "التحويل إلى الافتراضي",
  "switch to 3pl (forwarded awb)": "التحويل إلى 3PL (بوليصة الشحن المحولة)",
  "size": "الحجم",
  "no. of pieces is required": "عدد القطع مطلوب",
  "at least 1 piece is required": "يجب تحديد قطعة واحدة على الأقل",
  "maximum allowed is 9999 pieces": "الحد الأقصى المسموح به هو 9999 قطعة",
  "label generated successfully": "تم إنشاء البوليصة بنجاح",
  "failed to generate label": "فشل في إنشاء البوليصة",
  "generating...": "جاري الإنشاء...",
  "creating...": "جاري الإنشاء...",
  "completed": "مكتمل",
  "in progress": "قيد التنفيذ",
  "generated": "تم الإنشاء",
  "created": "تم الإنشاء",
  "picking": "جارٍ التجهيز أو الالتقاط",
  "assigned": "تم التعيين",
  "picklist number": "رقم قائمة التحضير",
  "total orders": "إجمالي الطلبات",
  "picker": "عامل الالتقاط / الموظف المسؤول عن الالتقاط",
  "created by": "أنشئ بواسطة",
  "assigned to": "مخصص لـ",
  "created date": "تاريخ الإنشاء",
  "started date": "تاريخ البدء",
  "completed date": "تاريخ الاكتمال",
  "barcode": "الباركود",
  "notes": "ملاحظات",
  "all": "الكل",
  "pick list order view": "عرض طلب قائمة الالتقاط",
  "skus": "أكواد السلع",
  "picklist barcode": "باركود قائمة الالتقاط",
  "warehouse details": "تفاصيل المستودع",
  "city/district": "المدينة/الحي",
  "zone/dock": "المنطقة/الرصيف",
  "order line details": "تفاصيل بنود الطلب",
  "awb, sku & storage location barcodes": "باركود بوليصة الشحن، كود السلعة وموقع التخزين",
  "quantity": "الكمية",
  "unassigned picker": "عامل الالتقاط غير معين",
  "units": "وحدات",
  "unassigned": "غير معين",
  "morning shift": "فترة الصباح",
  "afternoon shift": "فترة بعد الظهر",
  "night shift": "فترة الليل",
  "n/a": "غير متوفر",
  "no picklists found": "لم يتم العثور على قوائم التقاط",
  "failed to load picklist details": "فشل في تحميل تفاصيل قائمة الالتقاط",
  "go back": "العودة",
  "mark as picked": "تحديد كمجهز أو تم انتقاؤه",
  "assign staff": "تعيين الموظفين",
  "print picklist": "طباعة قائمة الالتقاط",
  "delete picklist": "حذف قائمة الالتقاط",
  "switch to default label print": "التحويل إلى طباعة الملصق الافتراضية",
  "4 x 6 inches": "٤ × ٦ بوصة",
  "label": "الملصق",
  "awb number(s) are required.": "أرقام بوالص الشحن مطلوبة.",
  "only alphanumeric characters and new lines are allowed.": "يُسمح فقط بالأحرف الأبجدية الرقمية والأسطر الجديدة.",
  "reverse created successfully": "تم إنشاء الطلب العكسي بنجاح",
  "failed to create reverse order": "فشل في إنشاء الطلب العكسي",
  "delete": "حذف",
  "comment": "ملاحظة",
  "are you sure want to delete?": "هل أنت متأكد من رغبتك في الحذف؟",
  "are you sure ?": "هل أنت متأكد؟",
  "want to delete this picking? this action cannot be undone.": "هل تريد حذف قائمة التحضير هذه؟ لا يمكن التراجع عن هذا الإجراء.",
  "search staff name...": "البحث عن اسم الموظف...",
  "loading staff": "جاري تحميل الموظفين",
  "no staff found matching": "لم يتم العثور على موظف يطابق",
  "select print type": "اختر نوع الطباعة",
  "print pickup list / print list seller / print pickup list a4 / print awb 4*6 / print awb a4": "طباعة قائمة الاستلام / طباعة قائمة البائع / طباعة قائمة الاستلام A4 / طباعة بوليصة الشحن 4*6 / طباعة بوليصة الشحن A4",
  "fetching details": "جاري جلب التفاصيل",
  "sender info": "بيانات المرسل",
  "receiver info": "بيانات المستلم",
  "contact": "الاتصال",
  "cod amount: 0": "مبلغ الدفع عند الاستلام: 0",
  "item icon": "أيقونة العنصر",
  "shelve#": "الرف#",
  "sku name": "اسم كود السلعة",
  "no details available to print": "لا توجد تفاصيل متاحة للطباعة",
  "processing...": "جاري المعالجة...",
  "print now": "اطبع الآن",
  "print": "طباعة",
  "bulk upload": "تحميل مجمع",
  "order type:": "نوع الطلب:",
  "upload": "رفع",
  "csv file": "ملف CSV",
  "upload a csv file only (max size: 2 mb).": "رفع ملف CSV فقط (الحجم الأقصى: 2 ميجابايت).",
  "selected file:": "الملف المختار:",
  "include product details (product id & quantity) for each order.": "قم بتضمين تفاصيل المنتج (معرف المنتج والكمية) لكل طلب.",
  "weight will be calculated from products - do not include weight column.": "سيتم حساب الوزن من المنتجات - لا تقم بتضمين عمود الوزن.",
  "please select a file first": "يرجى تحديد ملف أولاً",
  "lm orders uploaded successfully": "تم رفع طلبات الميل الأخير بنجاح",
  "fm orders uploaded successfully": "تم رفع طلبات الميل الأول بنجاح",
  "failed to upload orders": "فشل في رفع الطلبات",
  "bulk status update": "تحديث الحالة المجمع",
  "columns": "الأعمدة",
  "choose status": "اختر الحالة",
  "order_created": "تم إنشاء الطلب",
  "picklist_generated": "تم إنشاء قائمة الالتقاط",
  "new_order": "طلب جديد",
  "order_generated": "تم توليد الطلب",
  "ready_for_pickup": "جاهز للاستلام",
  "ready_to_pick": "جاهز للانتقاء",
  "in_transit": "في الطريق",
  "out_for_delivery": "خرج للتسليم",
  "undelivered": "لم يُسلَّم",
  "reverse_new": "إرجاع جديد",
  "receive_in_warehouse": "استلام في المستودع",
  "pickup_generated": "تم إنشاء طلب الاستلام",
  "return_to_shipper": "إرجاع إلى المرسل",
  "forward_to_3pl": "تحويل إلى شركة شحن خارجية (3PL)",
  "dispatched_to_3pl": "تم الشحن إلى شركة شحن خارجية (3PL)",
  "pickup_collected": "تم استلام الشحنة",
  "receive_inbound": "استلام وارد",
  "shelve": "تخزين على الرف",
  "pending_stock": "بانتظار توفر المخزون",
  "paste awb numbers or reference ids below to transition them to": "الصق أرقام بوليصة الشحن أو معرفات المرجع أدناه للانتقال إلى",
  "status. only orders in the previous logical status will be updated.": "الحالة. سيتم تحديث الطلبات في الحالة السابقة فقط.",
  "picklist type": "نوع قائمة الالتقاط",
  "batch order": "طلب دفعي",
  "single order": "طلب منفرد",
  "assign staff (optional)": "تعيين موظف (اختياري)",
  "select a staff member...": "اختر موظفاً...",
  "instantly update picklist to completed and orders to picked": "تحديث قائمة الالتقاط فورًا إلى مكتمل والطلبات إلى تم التجهيز أو تم الانتقاء",
  "paste identifiers here (e.g. tr1001, obp1000000049)...": "الصق المعرفات هنا (مثال: TR1001، OBP1000000049)...",
  "detected": "تم اكتشاف",
  "unique identifiers": "معرفات فريدة",
  "waiting for input...": "في انتظار الإدخال...",
  "close": "إغلاق",
  "please enter at least one identifier": "يرجى إدخال معرف واحد على الأقل",
  "bulk update successful": "تم التحديث المجمع بنجاح",
  "failed to process orders": "فشل في معالجة الطلبات",
  "an error occurred during bulk update": "حدث خطأ أثناء التحديث المجمع",
  "csv template downloaded successfully": "تم تنزيل نموذج CSV بنجاح",
  "failed to generate csv template": "فشل في إنشاء نموذج CSV",
  "template not available": "النموذج غير متوفر",
  "fm csv template downloaded successfully": "تم تنزيل نموذج FM CSV بنجاح",
  "failed to generate fm csv template": "فشل في إنشاء نموذج FM CSV",
  "write reason...": "اكتب السبب...",
  "actual qty.": "الكمية الفعلية",
  "return qty.": "كمية المرتجع",
  "return reason": "سبب الإرجاع",
  "cancel reason": "سبب الإلغاء",
  "item name": "اسم العنصر",
  "confirm status revert": "تأكيد التراجع عن الحالة",
  "are you sure you want to revert the status of these orders?": "هل أنت متأكد أنك تريد التراجع عن حالة هذه الطلبات؟",
  "reverting...": "جاري التراجع...",
  "status reverted successfully": "تم التراجع عن الحالة بنجاح",
  "failed to revert status": "فشل في التراجع عن الحالة",

  // Tabs & Navigation
  "staff": "طاقم العمل",
  "staff list": "قائمة الموظفين",
  "add staff": "إضافة موظف",
  "edit staff": "تعديل الموظف",
  "staff name": "اسم الموظف",
  "staff role": "دور الموظف",
  "personal info": "المعلومات الشخصية",
  "personal information": "المعلومات الشخصية",
  "file size must be 1 mb or less": "يجب أن يكون حجم الملف 1 ميجابايت أو أقل",
  "only jpg, jpeg, or png allowed": "يسمح فقط بملفات JPG أو JPEG أو PNG",
  "staff profile": "الملف الشخصي للموظف",
  "upload photo": "تحميل الصورة",
  "accepted formats: png, jpg (max file size: 1 mb)": "الصيغ المقبولة: PNG، JPG (الحد الأقصى لحجم الملف: 1 ميجابايت)",
  "name is required": "الاسم مطلوب",
  "name must contain at least one letter": "يجب أن يحتوي الاسم على حرف واحد على الأقل",
  "name cannot be empty or only spaces": "لا يمكن أن يكون الاسم فارغاً أو يحتوي على مسافات فقط",
  "mobile number must be 9 or 10 digits": "يجب أن يكون رقم الجوال من 9 أو 10 أرقام",
  "mobile number cannot be all zeros": "لا يمكن أن يكون رقم الجوال كله أصفار",
  "email is required": "البريد الإلكتروني مطلوب",
  "please enter a valid email address": "الرجاء إدخال بريد إلكتروني صحيح",
  "leave blank to keep ...": "اتركه فارغاً للاحتفاظ بـ ...",
  "password must be at least 8 characters": "يجب أن تكون كلمة المرور 8 رموز على الأقل",
  "password must not exceed 16 characters": "يجب ألا تتجاوز كلمة المرور 16 رمزاً",
  "must contain one uppercase letter": "يجب أن تحتوي على حرف كبير واحد",
  "must contain one lowercase letter": "يجب أن تحتوي على حرف صغير واحد",
  "must contain one number": "يجب أن تحتوي على رقم واحد",
  "must contain one special character": "يجب أن تحتوي على رمز خاص واحد",
  "work assignment": "مهمة العمل",
  "warehouse / outlet": "المستودع / المنفذ",
  "search location...": "البحث عن موقع...",
  "warehouse or outlet is required": "المستودع أو المنفذ مطلوب",
  "country is required": "الدولة مطلوبة",
  "loading cities...": "جاري تحميل المدن...",
  "city is required": "المدينة مطلوبة",
  "loading districts...": "جاري تحميل الأحياء...",
  "district is required": "الحي مطلوب",
  "select dark store": "اختر المتجر الداكن",
  "dark store is required": "المتجر الداكن مطلوب",
  "supervisor": "المشرف",
  "assign role (outlet)": "تعيين دور (المنفذ)",
  "assign role": "تعيين دور",
  "staff role is required": "دور الموظف مطلوب",
  "start date": "تاريخ البدء",
  "start date is required": "تاريخ البدء مطلوب",
  "future dates are not allowed": "غير مسموح بالتواريخ المستقبلية",
  "at least one warehouse or outlet is required": "مستودع واحد أو منفذ واحد على الأقل مطلوب",
  "assign additional warehouses / outlets": "تعيين مستودعات / منافذ إضافية",
  "multiple warehouse": "مستودعات متعددة",
  "multiple warehouses": "مستودعات متعددة",
  "identification & documents": "الهوية والمستندات",
  "iqama number": "رقم الإقامة",
  "iqama number is required": "رقم الإقامة مطلوب",
  "iqama number must be 10 digits": "يجب أن يكون رقم الإقامة 10 أرقام",
  "new password": "كلمة مرور جديدة",
  "as outsource": "كخارج مصدر",
  "driver added successfully.": "تم إضافة السائق بنجاح.",
  "something went wrong": "حدث خطأ ما",
  "failed to update client.": "فشل تحديث بيانات العميل.",
  "view driver": "عرض السائق",
  "image": "الصورة",
  "document": "المستند",
  "✓ uploaded file": "✓ تم رفع الملف",
  "add driver": "إضافة سائق",
  "workplace": "مكان العمل",
  "vehicle info": "بيانات المركبة",
  "driver code": "رمز السائق",
  "driver type": "نوع السائق",
  "route code": "رمز المسار",
  "iqama": "الإقامة",
  "license": "الرخصة",
  "rc": "الاستمارة",
  "vehicle inspection": "فحص المركبة",
  "assigned date": "تاريخ التعيين",
  "personal details": "البيانات الشخصية",
  "vehicle details": "تفاصيل المركبة",
  "employment details": "تفاصيل العمل",
  "identification documents": "وثائق الهوية",
  "outsource company": "الشركة الخارجية",
  "supervisor (optional)": "المشرف (اختياري)",
  "vehicle type (optional)": "نوع المركبة (اختياري)",
  "assign vehicle (optional)": "تعيين المركبة (اختياري)",
  "driver details": "تفاصيل السائق",
  "edit driver": "تعديل السائق",
  "license number": "رقم الرخصة",
  "license number must be exactly 10 digits": "يجب أن يكون رقم الرخصة 10 أرقام",
  "license number is required": "رقم الرخصة مطلوب",
  "vehicle name": "اسم المركبة",
  "vehicle number": "رقم المركبة",
  "dark store": "المتجر الداكن",
  "file is required": "الملف مطلوب",
  "please select a file": "الرجاء اختيار ملف",
  "only jpg, jpeg, png, or pdf files are allowed": "يسمح فقط بملفات JPG أو JPEG أو PNG أو PDF",
  "import staff": "استيراد الموظفين",
  "activate": "تنشيط",
  "deactivate": "إلغاء التنشيط",
  "primary warehouse": "المستودع الرئيسي",
  "assigned warehouse": "المستودع المعين",
  "no additional warehouses assigned": "لم يتم تعيين مستودعات إضافية",
  "role permissions": "صلاحيات الدور",
  "no permissions found": "لم يتم العثور على صلاحيات",
  "try a different search term": "جرّب مصطلح بحث آخر",
  "no permissions assigned to this role": "لا توجد صلاحيات معينة لهذا الدور",
  "staff added successfully.": "تم إضافة الموظف بنجاح.",
  "please add role before creating staff": "الرجاء إضافة دور قبل إنشاء موظف",
  "you do not have permission to update staff status": "ليس لديك الصلاحية لتحديث حالة الموظف",
  "staffs": "طاقم العمل",
  "bulk upload staff": "تحميل مجمع للموظفين",
  "please select a file to upload": "الرجاء اختيار ملف لرفعه",
  "mandatory fields: sender, receiver, reference, etc.": "الحقول الإلزامية: المرسل، المستلم، المرجع، إلخ.",
  "roles": "الأدوار",
  "iqama no": "رقم الإقامة",
  "updating...": "جاري التحديث...",
  "update failed": "فشل التحديث",
  "staff updated successfully": "تم تحديث الموظف بنجاح.",
  "staff updated successfully.": "تم تحديث الموظف بنجاح.",
  "loading...": "جاري التحميل...",
  "loading roles...": "جاري تحميل الأدوار...",
  "no roles available": "لا توجد أدوار متاحة",
  "you must create at least one staff role in the access control section before you can add a staff member.": "يجب عليك إنشاء دور موظف واحد على الأقل في قسم التحكم في الوصول قبل أن تتمكن من إضافة موظف.",
  "adding...": "جاري الإضافة...",
  "add": "إضافة",
  "remove": "إزالة",
  "access center": "مركز الوصول",
  "client request": "طلبات العملاء",
  "password": "كلمة المرور",
  "merchant": "التاجر",
  "merchant information": "معلومات التاجر",
  "merchant office address": "عنوان مكتب التاجر",
  "business details": "بيانات العمل",
  "legal information": "المعلومات القانونية",
  "business name": "الاسم التجاري",
  "merchant type": "نوع التاجر",
  "start contract date": "تاريخ بدء العقد",
  "tax/vat number": "الرقم الضريبي",
  "upload logo": "تحميل الشعار",
  "nippco": "نيبكو",
  "preferred contact method": "طريقة التواصل المفضلة",
  "bulk upload merchant": "تحميل مجمع للتجار",
  "bulk upload drivers": "تحميل مجمع للسائقين",
  "bulk upload outsource": "تحميل مجمع لمزودي الخدمة الخارجيين",
  "out source details": "تفاصيل مزود الخدمة الخارجي",
  "edit out source": "تعديل مزود الخدمة الخارجي",
  "outsource update successfully.": "تم تحديث مزود الخدمة الخارجي بنجاح.",
  "outsource added successfully.": "تم إضافة مزود الخدمة الخارجي بنجاح.",
  "failed to update outsource.": "فشل تحديث مزود الخدمة الخارجي.",
  "add company": "إضافة شركة",
  "primary contact": "جهة الاتصال الأساسية",
  "other details": "تفاصيل أخرى",
  "tax/vat": "الضريبة/القيمة المضافة",
  "billing": "الفوترة",
  "coverage": "التغطية",
  "specializations": "التخصصات",
  "no drivers found": "لا يوجد سائقون",
  "company details": "تفاصيل الشركة",
  "contract details": "تفاصيل العقد",
  "contact person name": "اسم الشخص المسؤول",
  "mail id": "البريد الإلكتروني",
  "specialization": "التخصص",
  "billing cycle": "دورة الفوترة",
  "area coverage": "نطاق التغطية",
  "contract start date": "تاريخ بداية العقد",
  "contract end date (optional)": "تاريخ انتهاء العقد (اختياري)",
  "enter 15 digit vat number": "أدخل 15 رقمًا لضريبة القيمة المضافة",
  "primary contact name (optional)": "اسم جهة الاتصال الأساسية (اختياري)",
  "primary phone number (optional)": "رقم الهاتف الأساسي (اختياري)",
  "primary email address (optional)": "البريد الإلكتروني الأساسي (اختياري)",
  "✓ uploaded": "✓ تم الرفع",
  "primary/other": "أساسي/أخرى",
  "number": "الرقم",
  "enter full name/ business name": "أدخل الاسم الكامل/الاسم التجاري",
  "enter mobile number": "أدخل رقم الجوال",
  "enter email address": "أدخل البريد الإلكتروني",
  "enter contact person name": "أدخل اسم الشخص المسؤول",
  "edit merchant": "تعديل التاجر",
  "failed merchant excel downloaded successfully": "تم تنزيل ملف إكسل التجار الفاشلين بنجاح",
  "failed to generate excel file": "فشل إنشاء ملف إكسل",
  "no failed data available to download": "لا تتوفر بيانات فاشلة لتنزيلها",
  "upload status report": "تقرير حالة التحميل",
  "data uploaded successfully": "تم تحميل البيانات بنجاح",
  "successfully data list": "قائمة البيانات الناجحة",
  "failed data list": "قائمة البيانات الفاشلة",
  "failed data": "البيانات الفاشلة",
  "records failed to upload. review the csv file, correct the errors, and re-upload.": "سجلات فشل تحميلها. يرجى مراجعة ملف CSV، وتصحيح الأخطاء، وإعادة التحميل.",
  "we found": "وجدنا",
  "note:": "ملاحظة:",
  "drivers": "السائقين",
  "out source": "مزود خدمة خارجي",
  "access control": "التحكم بالوصول",
  "requests": "الطلبات",
  "active": "نشط",
  "inactive": "غير نشط",
  "total": "الإجمالي",
  "active drivers:": "السائقين النشطين:",
  "open drs:": "بيانات التوصيل المفتوحة:",
  "delivered:": "تم التوصيل:",
  "wallet risk:": "مخاطر المحفظة:",
  "riw queue:": "طابور الاستلام:",
  "ready:": "جاهز:",
  "pending cod:": "الدفع عند الاستلام المعلق:",
  "exposure:": "التعرض للمخاطر:",
  "open cases:": "الحالات المفتوحة:",
  "inprocess": "قيد المعالجة",
  "not del": "لم يتم التوصيل",
  "dispatch ofd / riw": "شحن للتوصيل / استلام في المستودع",
  "select not delivered awb": "اختر بوليصة شحن لم يتم توصيلها",
  "generate swap": "إنشاء طلب تبديل",
  "select awb to swap": "اختر بوليصة شحن للتبديل",
  "select swap request awb": "اختر طلب تبديل بوليصة الشحن",
  "only swap req shipment can be assign driver": "يمكن فقط تعيين سائق لشحنات طلب التبديل",
  "swap driver / assign driver": "تبديل السائق / تعيين سائق",
  "swap": "تبديل",
  "swapped": "تم التبديل",
  "accepted": "مقبول",
  "pending orders": "الطلبات المعلقة",
  "search by...": "البحث بواسطة...",
  "search type": "نوع البحث",
  "reference": "المرجع",

  // Headers & Common Table Columns
  "s/n": "الرقم التسلسلي",
  "tag": "علامة",
  "date": "التاريخ",
  "platform": "المنصة",
  "awb / ref": "بوليصة الشحن / المرجع",
  "awb & ref": "بوليصة الشحن / المرجع",
  "warehouse": "المستودع",
  "route": "الطريق",
  "3pl shipping": "الشحن عبر شركة شحن خارجية (3PL)",
  "3pl shipping details": "تفاصيل شحن شركة خارجية (3PL)",
  "origin": "المصدر",
  "destination": "الوجهة",
  "receiver": "المستلم",
  "receiver details": "تفاصيل المستلم",
  "payment": "الدفع",
  "payment info": "معلومات الدفع",
  "status": "الحالة",
  "items": "العناصر",
  "view": "عرض",
  "actions": "الإجراءات",

  // Card & Section Titles
  "sender details": "تفاصيل المرسل",
  "company name": "اسم الشركة",
  "account ref no": "رقم الحساب المرجعي",
  "account ref no.": "رقم الحساب المرجعي",
  "full name": "الاسم الكامل",
  "mobile": "رقم الجوال",
  "email": "البريد الإلكتروني",
  "address": "العنوان",
  "city / area": "المدينة / المنطقة",
  "national address": "العنوان الوطني",
  "coordinates": "الإحداثيات",
  "open": "فتح",
  "timeline": "خط سير الشحنة",

  // New keys added for CreatedOrders and PickList pages
  "filter settings": "إعدادات الفلتر",
  "awb no. (optional)": "رقم بوليصة الشحن (اختياري)",
  "enter awb, reference number,  or mobile number (comma-separated for multiple)": "أدخل رقم بوليصة الشحن، أو الرقم المرجعي، أو رقم الجوال (مفصولة بفاصلة للمتعدد)",
  "select seller": "اختر البائع",
  "payment mode": "طريقة الدفع",
  "select payment mode": "اختر طريقة الدفع",
  "0.5 sar": "0.5 ريال",
  "same date": "نفس التاريخ",
  "entry date range": "نطاق تاريخ الإدخال",
  "close date range": "نطاق تاريخ الإغلاق",
  "origin country": "بلد المنشأ",
  "select country": "اختر البلد",
  "origin city": "مدينة المنشأ",
  "select city": "اختر المدينة",
  "destination country": "بلد الوجهة",
  "destination city": "مدينة الوجهة",
  "destination district": "حي الوجهة",
  "order info": "معلومات الطلب",
  "service type": "نوع الخدمة",
  "select order type": "اختر نوع الطلب",
  "select platform": "اختر المنصة",
  "shipping company": "شركة الشحن",
  "select shipping company": "اختر شركة الشحن",
  "apply filters": "تطبيق الفلاتر",
  "from": "من",
  "to": "إلى",
  "seller": "البائع",
  "details": "التفاصيل",
  "reverse new": "إرجاع جديد",

  // Milestones & Statuses

  // Milestones & Statuses
  "order": "طلب",
  "orders": "طلبات",
  "draft": "مسودة",
  "new order": "طلب جديد",
  "order generated": "تم إنشاء الطلب",
  "order created": "تم إنشاء الطلب",
  "processing": "جاري المعالجة",
  "ready for pickup": "جاهز للاستلام",
  "pickup generated": "تم إنشاء طلب الاستلام",
  "pickup collected": "تم استلام الشحنة",
  "receive inbound": "استلام الوارد",
  "received in warehouse": "تم الاستلام في المستودع",
  "receive in warehouse": "تم الاستلام في المستودع",
  "shelving": "جارٍ التخزين على الرفوف",
  "shelved": "تم الوضع على الرف",
  "in warehouse": "في المستودع",
  "arrived at warehouse": "وصل إلى المستودع",
  "dispatched": "تم الشحن",
  "dispatched to 3pl": "تم الشحن إلى شركة شحن خارجية (3PL)",
  "forwarded to 3pl": "تم التحويل إلى شركة شحن خارجية (3PL)",
  "in transit": "في الطريق",
  "out for delivery": "خارج للتوصيل",
  "departed": "غادر",
  "picked up": "تم الاستلام",
  "delivered": "تم التوصيل",
  "not delivered": "لم يتم التوصيل",
  "returned": "تم الإرجاع",
  "return to shipper": "إرجاع إلى المرسل",
  "reverse order": "طلب إرجاع",
  "cancelled": "ملغي",
  "failed": "فشل",
  "lost": "مفقود",
  "damaged": "تالف",
  "pending": "معلق",
  "pending stock": "بانتظار توفر المخزون",
  "picklist generated": "تم إنشاء قائمة الالتقاط",
  "picked": "تم التجهيز أو تم الانتقاء",
  "packed": "تم التغليف",
  "reverted": "تم التراجع عنه",
  "deleted": "تم الحذف",

  // Shipment & Product details
  "shipment details": "تفاصيل الشحنة",
  "items details": "تفاصيل العناصر",
  "shipment": "الشحنة",
  "entry date": "تاريخ الإدخال",
  "close date": "تاريخ الإغلاق",
  "reference number": "رقم المرجع",
  "ref:": "المرجع:",
  "warehouse location": "موقع المستودع",
  "shelf / shelf no.": "الرف / رقم الرف",
  "product category": "فئة المنتج",
  "delivery route code": "رمز طريق التوصيل",
  "delivery attempts": "محاولات التوصيل",
  "weight": "الوزن",
  "pieces": "القطع",
  "service": "الخدمة",
  "item": "العنصر",
  "sku": "رمز التخزين (SKU)",
  "qty": "الكمية",
  "price": "السعر",
  "variant": "النوع",
  "in stock": "متوفر في المخزون",
  "out of stock": "غير متوفر في المخزون",
  "partial stock": "متوفر جزئياً",
  "stock status": "حالة المخزون",
  "pending reason": "سبب التعليق",
  "available": "متوفر",
  "0 available": "0 متوفر",
  "available stock": "المخزون المتوفر",
  "pending stock notice": "إشعار توفر المخزون",
  "this order is waiting for stock. the following sku(s) are out of stock:": "هذا الطلب بانتظار توفر المخزون. رموز SKU التالية غير متوفرة:",
  "all items are currently in stock. you can split or fulfill this order.": "جميع العناصر متوفرة حالياً في المخزون. يمكنك تقسيم الطلب أو معالجته.",
  "description": "الوصف",

  // Users & Roles
  "role": "الدور",
  "Role Access": "صلاحيات الأدوار",
  "Client Access": "صلاحيات العملاء",
  "Manage roles and permissions": "إدارة الأدوار والصلاحيات",
  "Manage client access rights": "إدارة حقوق وصول العملاء",
  "Select a module to manage permissions.": "حدد وحدة لإدارة الصلاحيات.",
  "Single": "فردي",
  "Multiple": "متعدد",
  "Select All Permissions": "تحديد كل الصلاحيات",
  "Delete Role": "حذف الدور",
  "Edit Role": "تعديل الدور",
  "View Role": "عرض الدور",
  "Create New Role": "إنشاء دور جديد",
  "Please Select Role": "الرجاء تحديد الدور",
  "You don't have any Role yet.": "ليس لديك أي دور بعد.",
  "Are you sure you want to delete the role \"{roleName}\"?": "هل أنت متأكد من رغبتك في حذف الدور \"{roleName}\"؟",
  "Role deleted successfully.": "تم حذف الدور بنجاح.",
  "Failed to delete role": "فشل حذف الدور",
  "Role Added Successfully.": "تم إضافة الدور بنجاح.",
  "Role Updated Successfully.": "تم تحديث الدور بنجاح.",
  "Clients": "العملاء",
  "Edit Client Permissions": "تعديل صلاحيات العميل",
  "Please Select Client": "الرجاء اختيار عميل",
  "Select a client to manage access": "اختر عميلاً لإدارة الصلاحيات",
  "Update Access": "تحديث الصلاحيات",
  "Please select at least one permission": "الرجاء اختيار صلاحية واحدة على الأقل",
  "Access updated successfully": "تم تحديث الصلاحيات بنجاح",
  "Loading permissions...": "جاري تحميل الصلاحيات...",
  "phone": "الهاتف",
  "view profile": "عرض الملف الشخصي",
  "outsource": "مزود خدمة خارجي",
  "inhouse": "داخلي",
  "type": "النوع",
  "company info": "معلومات الشركة",
  "locations": "المواقع",
  "documents": "المستندات",
  "channels": "القنوات",
  "merchant id": "رقم تعريف التاجر",
  "secret key": "المفتاح السري",
  "contract date": "تاريخ العقد",
  "vat number": "الرقم الضريبي",
  "cr number": "رقم السجل التجاري",
  "national id": "الهوية الوطنية",
  "company information": "معلومات الشركة",
  "my profile": "ملفي الشخصي",
  "profile details": "تفاصيل الملف الشخصي",
  "enter full name": "أدخل الاسم الكامل",
  "full name is required": "الاسم الكامل مطلوب",
  "name must include at least one letter": "يجب أن يحتوي الاسم على حرف واحد على الأقل",
  "email address": "البريد الإلكتروني",
  "phone number": "رقم الهاتف",
  "enter phone number": "أدخل رقم الهاتف",
  "mobile number must be 10 characters": "يجب أن يكون رقم الجوال 10 أرقام",
  "download iqama": "تحميل الإقامة",
  "assigned role": "الدور المعين",
  "time slot name": "اسم الفترة الزمنية",
  "selected warehouse": "المستودع المحدد",
  "assigned warehouses": "المستودعات المعينة",
  "no warehouses assigned": "لم يتم تعيين مستودعات",
  "company name is required": "اسم الشركة مطلوب",
  "company name must include at least one letter (not only numbers)": "يجب أن يحتوي اسم الشركة على حرف واحد على الأقل (ليس أرقاماً فقط)",
  "company name cannot be empty or only spaces": "لا يمكن أن يكون اسم الشركة فارغاً أو يحتوي على مسافات فقط",
  "contact person is required": "الشخص المسؤول مطلوب",
  "contact person name must include at least one letter (not only numbers)": "يجب أن يحتوي اسم الشخص المسؤول على حرف واحد على الأقل (ليس أرقاماً فقط)",
  "contact person name cannot be empty or only spaces": "لا يمكن أن يكون اسم الشخص المسؤول فارغاً أو يحتوي على مسافات فقط",
  "mail address": "البريد الإلكتروني",
  "postal / zip code is required": "الرمز البريدي مطلوب",
  "tax/vat number must be 15 digits": "يجب أن يكون الرقم الضريبي 15 رقماً",
  "only jpg, jpeg, pdf, or png files are allowed": "يسمح فقط بملفات JPG أو JPEG أو PDF أو PNG",
  "cr number is required": "رقم السجل التجاري مطلوب",
  "cr number must be 10 numbers": "يجب أن يكون رقم السجل التجاري 10 أرقام",
  "only jpg, jpeg, pdf, or png allowed": "يسمح فقط بملفات JPG أو JPEG أو PDF أو PNG",
  "info email is required": "البريد الإلكتروني للمعلومات مطلوب",
  "postal / zip code": "الرمز البريدي",
  "address line": "العنوان",
  "awb info": "معلومات بوليصة الشحن",
  "fulfillment": "التجهيز",
  "lastmiles": "الميل الأخير",
  "vat percent & number": "رقم ونسبة ضريبة القيمة المضافة",
  "info email": "البريد الإلكتروني للمعلومات",
  "awb toll free no": "الرقم المجاني لبوليصة الشحن",
  "reset password": "إعادة تعيين كلمة المرور",
  "current password": "كلمة المرور الحالية",
  "confirm password": "تأكيد كلمة المرور",
  "minimum 8 characters, must include one number, one uppercase, and one lowercase character.": "الحد الأدنى 8 رموز، يجب أن يحتوي على رقم وحرف كبير وحرف صغير.",
  "country / currency": "البلد / العملة",
  "select date format": "اختر صيغة التاريخ",
  "date format": "صيغة التاريخ",
  "time zone": "المنطقة الزمنية",
  "currency is required": "العملة مطلوبة",
  "timezone is required": "المنطقة الزمنية مطلوبة",
  "date format is required": "صيغة التاريخ مطلوبة",
  "current password is required": "كلمة المرور الحالية مطلوبة",
  "new password is required": "كلمة المرور الجديدة مطلوبة",
  "confirm password is required": "تأكيد كلمة المرور مطلوب",
  "passwords do not match": "كلمات المرور غير متطابقة",
  "password updated successfully!": "تم تحديث كلمة المرور بنجاح!",
  "failed to update password": "فشل تحديث كلمة المرور",
  "profile updated successfully.": "تم تحديث الملف الشخصي بنجاح.",
  "no changes were made.": "لم يتم إجراء أي تغييرات.",
  "configuration updated successfully.": "تم تحديث الإعدادات بنجاح.",
  "failed to update configuration.": "فشل تحديث الإعدادات.",
  "monday": "الإثنين",
  "tuesday": "الثلاثاء",
  "wednesday": "الأربعاء",
  "thursday": "الخميس",
  "friday": "الجمعة",
  "saturday": "السبت",
  "sunday": "الأحد",
  "mon": "الإثنين",
  "tue": "الثلاثاء",
  "wed": "الأربعاء",
  "thu": "الخميس",
  "fri": "الجمعة",
  "sat": "السبت",
  "sun": "الأحد",
  "shipping configuration": "إعدادات الشحن",
  "loading permissions...": "جاري تحميل الصلاحيات...",
  "failed to load permissions": "فشل في تحميل الصلاحيات",
  "you don't have access to any shipping configuration.": "ليس لديك صلاحية الوصول إلى أي إعدادات شحن.",
  "services info": "بيانات الخدمات",
  "add service": "إضافة خدمة",
  "edit service": "تعديل خدمة",
  "select a service option": "اختر أحد خيارات الخدمة",
  "standard delivery": "التوصيل القياسي",
  "standard delivery — delivery within 1–5 days based on location.": "التوصيل القياسي — التوصيل خلال 1-5 أيام بناءً على الموقع.",
  "express / priority delivery": "التوصيل السريع / ذو الأولوية",
  "express / priority delivery — faster delivery within 1–2 days.": "التوصيل السريع / ذو الأولوية — توصيل أسرع خلال 1-2 أيام.",
  "same-day delivery": "التوصيل في نفس اليوم",
  "same-day delivery — order delivered within 24 hours.": "التوصيل في نفس اليوم — يتم توصيل الطلب خلال 24 ساعة.",
  "scheduled delivery": "التوصيل المجدول",
  "scheduled delivery — delivered at a chosen date and time slot.": "التوصيل المجدول — يتم التوصيل في تاريخ وفترة زمنية محددة.",
  "bullet delivery — ultra-fast delivery within 3–6 hours.": "توصيل فائق السرعة — توصيل سريع جداً خلال 3-6 ساعات.",
  "service added successfully ✅": "تم إضافة الخدمة بنجاح ✅",
  "service updated successfully ✅": "تم تحديث الخدمة بنجاح ✅",
  "service name": "اسم الخدمة",
  "service name is required": "اسم الخدمة مطلوب",
  "weight info": "معلومات الوزن",
  "for client": "للعميل",
  "weight range": "نطاق الوزن",
  "from (kg)": "من (كجم)",
  "to (kg)": "إلى (كجم)",
  "enter from kg": "أدخل من كجم",
  "enter only \"flat\"": "أدخل \"flat\" فقط",
  "weight added successfully": "تم إضافة الوزن بنجاح",
  "failed to create weight": "فشل في إنشاء الوزن",
  "weight updated successfully": "تم تحديث الوزن بنجاح",
  "failed to update weight": "فشل في تحديث الوزن",
  "please select a client": "يرجى اختيار العميل",
  "this field is required": "هذا الحقل مطلوب",
  "must be a valid number": "يجب أن يكون رقماً صالحاً",
  "must be a valid number or \"flat\"": "يجب أن يكون رقماً صالحاً أو \"flat\"",
  "to must be greater than from": "يجب أن يكون حقل 'إلى' أكبر من 'من'",
  "duplicate range detected": "تم كشف نطاق مكرر",
  "overlaps with another range": "يتداخل مع نطاق آخر",
  "by default": "افتراضي",
  "created type": "نوع المنشئ",
  "time slot info": "معلومات الفترة الزمنية",
  "add time slot": "إضافة فترة زمنية",
  "edit time slot": "تعديل فترة زمنية",
  "at least one day is required": "يجب اختيار يوم واحد على الأقل",
  "time range": "النطاق الزمني",
  "start time is required": "وقت البدء مطلوب",
  "end time is required": "وقت الانتهاء مطلوب",
  "enter time slot name": "أدخل اسم الفترة الزمنية",
  "time slot name is required": "اسم الفترة الزمنية مطلوب",
  "time slot name must include at least one letter (not only numbers)": "يجب أن يحتوي اسم الفترة الزمنية على حرف واحد على الأقل (ليس أرقاماً فقط)",
  "time slot name cannot be empty or only spaces": "لا يمكن أن يكون اسم الفترة الزمنية فارغاً أو يحتوي على مسافات فقط",
  "time slot created successfully.": "تم إنشاء الفترة الزمنية بنجاح.",
  "time slot updated successfully.": "تم تحديث الفترة الزمنية بنجاح.",
  "range": "النطاق",
  "for": "لأجل",
  "add category": "إضافة فئة",
  "edit category": "تعديل فئة",
  "select sub category": "اختر الفئة الفرعية",
  "select product fields": "اختر حقول المنتج",
  "select fields for": "اختر الحقول لـ",
  "select sub category first": "اختر الفئة الفرعية أولاً",
  "no fields selected": "لم يتم اختيار حقول",
  "category added successfully": "تم إضافة الفئة بنجاح",
  "category updated successfully": "تم تحديث الفئة بنجاح",
  "required fields": "الحقول المطلوبة",
  "edit price matrix": "تعديل مصفوفة الأسعار",
  "add new price matrix": "إضافة مصفوفة أسعار جديدة",
  "rate": "السعر / التعرفة",
  "enter rate": "أدخل السعر",
  "rate is required": "السعر مطلوب",
  "loading weight ranges...": "جاري تحميل نطاقات الوزن...",
  "enable 'for client'": "تمكين 'للعميل'",
  "return & cod fees": "رسوم المرتجعات والدفع عند الاستلام",
  "return price": "سعر الإرجاع",
  "enter return price": "أدخل سعر الإرجاع",
  "cod fee": "رسوم الدفع عند الاستلام",
  "enter cod fee": "أدخل رسوم الدفع عند الاستلام",
  "invalid price for": "سعر غير صالح لـ",
  "only numbers are allowed.": "مسموح بالأرقام فقط.",
  "price for": "سعر",
  "must be greater than 0": "يجب أن يكون أكبر من 0",
  "created!": "تم الإنشاء!",
  "updated!": "تم التحديث!",
  "system type": "نوع النظام",
  "change status?": "تغيير الحالة؟",
  "edit tier": "تعديل الشريحة",
  "add tier": "إضافة شريحة",
  "tier created successfully": "تم إنشاء الشريحة بنجاح",
  "tier updated successfully": "تم تحديث الشريحة بنجاح",
  "please select at least one city": "يرجى تحديد مدينة واحدة على الأقل",
  "tier name": "اسم الشريحة",
  "tier name is required": "اسم الشريحة مطلوب",
  "tier name name must include at least one letter (not only numbers)": "يجب أن يحتوي اسم الشريحة على حرف واحد على الأقل (ليس أرقاماً فقط)",
  "tier name name cannot be empty or only spaces": "لا يمكن أن يكون اسم الشريحة فارغاً أو يحتوي على مسافات فقط",
  "choose bulk upload": "اختر تحميل جماعي",
  "upload your file": "تحميل الملف الخاص بك",
  "accepted formats: .xls, .xlsx, .csv | max: 5mb": "الصيغ المقبولة: .xls, .xlsx, .csv | الحد الأقصى: 5 ميجابايت",
  "please upload the file in the same format as the downloaded file": "يرجى تحميل الملف بنفس صيغة الملف الذي تم تنزيله",
  "view cities": "عرض المدن",
  "cities list": "قائمة المدن",
  "coverage cities list": "قائمة مدن التغطية",
  "tier list": "قائمة الشرائح",
  "coverage tier list": "قائمة تغطية الشرائح",
  "list": "قائمة",
  "": "التغطية",
  "coming soon !!": "قريباً !!",
  "storage working are in-progress": "العمل على التخزين قيد التنفيذ",
  "customization saved": "تم حفظ التخصيص",
  "failed to save": "فشل في الحفظ",
  "premium wireless headphones": "سماعات لاسلكية ممتازة",
  "noise cancellation | 30h battery": "إلغاء الضوضاء | بطارية 30 ساعة",
  "noise cancellation | 30h battery life": "إلغاء الضوضاء | عمر بطارية 30 ساعة",
  "inclusive of all taxes": "شامل لجميع الضرائب",
  "select color": "اختر اللون",
  "select size": "اختر المقاس",
  "add to cart": "إضافة إلى السلة",
  "buy now": "اشترِ الآن",
  "customize product page": "تخصيص صفحة المنتج",
  "layout style": "نمط التخطيط",
  "image style": "نمط الصورة",
  "image ratio": "نسبة الصورة",
  "main image": "الصورة الرئيسية",
  "replace": "استبدال",
  "current:": "الحالي:",
  "extra images": "صور إضافية",
  "remove all": "إزالة الكل",
  "rating": "التقييم",
  "share": "مشاركة",
  "show variants option and selection": "عرض خيار المتغيرات والتحديد",
  "select quantity": "اختر الكمية",
  "cart": "السلة",
  "term & condition": "الشروط والأحكام",
  "layout": "التخطيط",
  "button style": "نمط الزر",
  "tax indication": "إشارة الضريبة",
  "more information": "مزيد من المعلومات",
  "★ 4.8 | 128 ratings": "★ 4.8 | 128 تقييم",
  "33% off": "خصم 33%",
  "premium wireless headphones with active noise cancellation, 30-hour battery life, and crystal-clear sound quality.": "سماعات لاسلكية ممتازة مع ميزة إلغاء الضوضاء النشطة، وعمر بطارية يصل إلى 30 ساعة، وجودة صوت فائقة الوضوح.",
  "main product image": "صورة المنتج الرئيسية",
  "item category": "فئة المنتج",
  "price matrix": "مصفوفة الأسعار",
  "marketplace": "المتجر الإلكتروني",
  "box name": "اسم الصندوق",
  "enter box name": "أدخل اسم الصندوق",
  "box name is required": "اسم الصندوق مطلوب",
  "box name must include at least one letter (not only numbers)": "يجب أن يحتوي اسم الصندوق على حرف واحد على الأقل (ليس أرقاماً فقط)",
  "box name cannot be empty or only spaces": "لا يمكن أن يكون اسم الصندوق فارغاً أو يحتوي على مسافات فقط",
  "min weight (kg)": "الوزن الأدنى (كجم)",
  "enter min weight (kg)": "أدخل الوزن الأدنى (كجم)",
  "enter width": "أدخل العرض",
  "enter height": "أدخل الارتفاع",
  "enter length": "أدخل الطول",
  "width (cm)": "العرض (سم)",
  "height (cm)": "الارتفاع (سم)",
  "length (cm)": "الطول (سم)",
  "min weight": "الوزن الأدنى",
  "boxes updated successfully": "تم تحديث الصناديق بنجاح",
  "boxes added successfully": "تم إضافة الصناديق بنجاح",
  "types": "الأنواع",
  "system": "النظام",
  "boxes": "الصناديق",
  "subscription & plans": "الاشتراك والخطط",
  "subscription": "الاشتراك",
  "plans": "الخطط",
  "subscription overview": "نظرة عامة على الاشتراك",
  "subscription status": "حالة الاشتراك",
  "current plan": "الخطة الحالية",
  "next billing date": "تاريخ الفاتورة القادم",
  "4 aug 2024": "٤ أغسطس ٢٠٢٤",
  "billing period": "فترة الفوترة",
  "monthly / yearly": "شهرياً / سنوياً",
  "included shipments": "الشحنات المشمولة",
  "30 free shipments / month": "٣٠ شحنة مجانية / شهر",
  "extra shipment rate": "سعر الشحنة الإضافية",
  "0 sar / extra shipment": "٠ ر.س / شحنة إضافية",
  "change plan": "تغيير الخطة",
  "payment details": "تفاصيل الدفع",
  "add payment method": "إضافة طريقة دفع",
  "payment method": "طريقة الدفع",
  "card / online": "بطاقة / عبر الإنترنت",
  "card type": "نوع البطاقة",
  "visa, mastercard": "فيزا، ماستركارد",
  "card last 4 digits": "آخر ٤ أرقام من البطاقة",
  "billing name": "اسم الفوترة",
  "billing address": "عنوان الفوترة",
  "update bank details": "تحديث تفاصيل البنك",
  "tips: the added payment method will be shown to the buyer during the transaction to accept fiat transfers.": "نصائح: ستظهر طريقة الدفع المضافة للمشتري أثناء المعاملة لقبول التحويلات النقدية.",
  "bank name*": "اسم البنك*",
  "bank name": "اسم البنك",
  "enter bank name": "أدخل اسم البنك",
  "account holder name*": "اسم صاحب الحساب*",
  "account holder name": "اسم صاحب الحساب",
  "enter account holder name": "أدخل اسم صاحب الحساب",
  "account number *": "رقم الحساب *",
  "account number": "رقم الحساب",
  "add account number": "أضف رقم الحساب",
  "ifsc code * ": "رمز IFSC * ",
  "ifsc code": "رمز IFSC",
  "enter ifsc code": "أدخل رمز IFSC",
  "branch name * ": "اسم الفرع * ",
  "branch name": "اسم الفرع",
  "enter branch name": "أدخل اسم الفرع",
  "basic": "أساسي",
  "premium": "ممتاز",
  "premium ": "ممتاز",
  "lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.": "نص لوريم إيبسوم هو نص وهمي أو نائب يستخدم عادة في التصميم الجرافيكي والنشر وتطوير الويب.",
  "/per month": " / شهرياً",
  "what's included?": "ما الذي تشمله الخطة؟",
  "fully customized to your business requirements": "مخصصة بالكامل لمتطلبات عملك",
  "scalable and future-proof architecture": "بنية أساسية قابلة للتطوير ومستقبلية",
  "robust security measures to protect your data": "تدابير أمنية قوية لحماية بياناتك",
  "comprehensive support and maintenance": "دعم وصيانة شاملة",
  "secure, cloud-based, and high-performance solutions": "حلول آمنة وسحابية وعالية الأداء",
  "choose plan": "اختيار الخطة",
  "plan name": "اسم الخطة",
  "preview details": "تفاصيل المعاينة",
  "phonepay": "فون باي",
  "plan price (basic)": "سعر الخطة (أساسي)",
  "platfrom fees": "رسوم المنصة",
  "platform fees": "رسوم المنصة",
  "tax fees": "الرسوم الضريبية",
  "confirm payment": "تأكيد الدفع",
  "phone pay": "فون باي",
  "card (visa/mastercard)": "بطاقة (فيزا/ماستركارد)",
  "union bank of india (neft/rtgs/imps)": "بنك يونيون الهندي (NEFT/RTGS/IMPS)",
  "activity logs": "سجلات الأنشطة",
  "activity": "النشاط",
  "fleet": "الأسطول",
  "select date range": "حدد النطاق الزمني",
  "end date": "تاريخ الانتهاء",
  "apply": "تطبيق",
  "reset": "إعادة ضبط",
  "success": "نجاح",
  "login": "تسجيل الدخول",
  "logout": "تسجيل الخروج",
  "applied filter :": "الفلتر المطبق:",
  "clients": "العملاء",
  "bulk uploads": "التحميلات الجماعية",
  "user name": "اسم المستخدم",
  "user type": "نوع المستخدم",
  "log id": "معرف السجل",
  "activity type": "نوع النشاط",
  "failed reason": "سبب الفشل",
  "logs filter": "فلترة السجلات",
  "app": "التطبيق",
  "web": "الموقع الإلكتروني",
  "tier": "الشريحة",
  "merchant office location": "موقع مكتب التاجر",
  "sales channel": "قناة المبيعات",
  "shopping channels": "قنوات التسوق",
  "no sales channels assigned": "لم يتم تعيين قنوات مبيعات",
  "no shipping channels assigned": "لم يتم تعيين قنوات شحن",
  "access": "وصول",
  "joined": "تاريخ الانضمام",
  "contact person": "الشخص المسؤول",
  "payment terms": "شروط الدفع",
  "coverage radius": "نطاق التغطية",
  "country": "البلد",
  "city": "المدينة",
  "district": "الحي",
  "short address": "العنوان المختصر",

  // Confirmation Modals
  "confirmation required": "تأكيد مطلوب",
  "are you sure you want to reverse this order?": "هل أنت متأكد أنك تريد عكس هذا الطلب؟",
  "are you sure you want to revert this order?": "هل أنت متأكد أنك تريد التراجع عن هذا الطلب؟",
  "cancel": "إلغاء",
  "confirm": "تأكيد",
  "reverse item": "عكس العنصر",
  "generate": "إنشاء",
  "cod": "الدفع عند الاستلام",
  "cc: paid": "بطاقة: مدفوع",
  "cc": "بطاقة ائتمان",
  "paid": "مدفوع",
  "revert status": "إرجاع الحالة",
  "awb no.": "رقم بوليصة الشحن",
  "select": "تحديد",
  "drs": "بيان التوصيل",
  "del": "تم التوصيل",
  "ret": "مرتجع",
  "in process": "قيد المعالجة",
  "cc paid": "بطاقة: مدفوع",

  // Create/Add Order Form Labels & Actions
  "next": "التالي",
  "back": "رجوع",
  "preview": "معاينة",
  "submit": "إرسال",
  "required": "مطلوب",
  "previous": "السابق",
  "failed to create order": "فشل في إنشاء الطلب",
  "order created successfully": "تم إنشاء الطلب بنجاح",
  "please fill all required fields": "يرجى ملء جميع الحقول المطلوبة",
  "parcel": "طرد",
  "cod amount": "مبلغ الدفع عند الاستلام",
  "no. pieces": "عدد القطع",
  "shipment cost": "تكلفة الشحنة",
  "shipment type": "نوع الشحنة",
  "add items": "إضافة عناصر",
  "select product": "اختر المنتج",
  "weight (kg)": "الوزن (كجم)",
  "please select a product": "يرجى اختيار منتج",
  "quantity is required": "الكمية مطلوبة",
  "qty ≥ 1": "الكمية ≥ 1",
  "invalid qty": "كمية غير صالحة",
  "invalid quantity": "الكمية غير صالحة",
  "order preview": "معاينة الطلب",
  "sender country is required": "بلد المرسل مطلوب",
  "sender name is required": "اسم المرسل مطلوب",
  "sender email is required": "البريد الإلكتروني للمرسل مطلوب",
  "invalid email": "بريد إلكتروني غير صالح",
  "client is required": "العميل مطلوب",
  "payment type is required": "طريقة الدفع مطلوبة",
  "cod amount is required": "مبلغ الدفع عند الاستلام مطلوب",
  "service is required": "الخدمة مطلوبة",
  "shipment type is required": "نوع الشحنة مطلوب",
  "reference is required": "المرجع مطلوب",
  "min 4 chars": "الحد الأدنى 4 أحرف",
  "max 16 chars": "الحد الأقصى 16 حرفًا",
  "4–16 characters": "4–16 حرفًا",
  "valid positive number": "رقم موجب صالح",
  "must be > 0": "يجب أن يكون أكبر من 0",
  "whole number": "رقم صحيح",
  "search...": "بحث...",
  "no results found": "لم يتم العثور على نتائج",

  // Additional form fields & map picker labels
  "ref": "المرجع",
  "cost": "التكلفة",
  "city / town": "المدينة / البلدة",
  "area / district / community": "المنطقة / الحي / المجتمع",
  "street": "الشارع",
  "building name / number": "اسم / رقم المبنى",
  "po box / postal code": "صندوق البريد / الرمز البريدي",
  "region / province": "المنطقة / المقاطعة",
  "short add (national address)": "العنوان المختصر (العنوان الوطني)",
  "postal code": "الرمز البريدي",
  "governorate": "المحافظة",
  "block": "المربع / الكتلة",
  "zone": "المنطقة / الزون",
  "road / avenue": "الطريق / الشارع العام",
  "wilayat": "الولاية",
  "short add": "العنوان المختصر",
  "lat": "خط العرض",
  "long": "خط الطول",
  "full address": "العنوان بالكامل",
  "district / neighbourhood": "الحي / المجاورة",

  // Placeholders, Map toggles, and new validations
  "name": "الاسم",
  "latitude": "خط العرض",
  "longitude": "خط الطول",
  "latitude is required": "خط العرض مطلوب",
  "longitude is required": "خط الطول مطلوب",
  "open map": "فتح الخريطة",
  "hide map": "إخفاء الخريطة",
  "mobile number": "رقم الجوال",
  "mobile number is required": "رقم الجوال مطلوب",
  "must include a letter": "يجب أن يحتوي على حرف",
  "cannot be empty": "لا يمكن أن يكون فارغاً",
  "e.g. dubai": "مثال: دبي",
  "e.g. riyadh region": "مثال: منطقة الرياض",
  "e.g. al olaya": "مثال: العليا",
  "e.g. sheikh zayed road": "مثال: شارع الشيخ زايد",
  "e.g. emirates tower": "مثال: برج الإمارات",
  "e.g. 12345": "مثال: 12345",
  "e.g. 11564": "مثال: 11564",
  "e.g. rhoo2375": "مثال: RHOO2375",
  "e.g. 24.7136": "مثال: 24.7136",
  "e.g. 46.6753": "مثال: 46.6753",
  "enter full address": "أدخل العنوان بالكامل",
  "e.g. capital": "مثال: العاصمة",
  "e.g. block 3": "مثال: بلوك 3",
  "e.g. zone 38": "مثال: زون 38",
  "e.g. road 22": "مثال: طريق 22",
  "e.g. muscat": "مثال: مسقط",
  "create order": "إنشاء طلب",
  "merchant details": "تفاصيل التاجر",
  "alternate address": "عنوان بديل",
  "For nippco merchant orders alternate address is mandatory": "العنوان البديل إلزامي لطلبات تاجر نيبكو",
  "Same Day": "في نفس اليوم",
  "search awb, route, carrier...": "البحث عن بوليصة الشحن، المسار، الناقل...",
  "search awb, order...": "البحث عن بوليصة الشحن، الطلب...",
  "dispatched manifests": "بيانات الشحن المرسلة",
  "selected:": "المحدد:",
  "total:": "الإجمالي:",
  "reset filters": "إعادة ضبط الفلاتر",
  "export to excel": "تصدير إلى إكسل",
  "sync pending orders": "مزامنة الطلبات المعلقة",
  "columns view": "عرض الأعمدة",
  "loading orders...": "جاري تحميل الطلبات...",
  "no pending orders found": "لم يتم العثور على طلبات معلقة",
  "bulk status change": "تغيير الحالة بالجملة",
  "no orders found matching the filter": "لم يتم العثور على طلبات تطابق الفلتر",
  "bulk generate picklist": "إنشاء قائمة الالتقاط بالجملة",
  "page": "صفحة",
  "of": "من",
  "clear & close": "مسح وإغلاق",
  "selected": "المحدد",
  "bulk status revert": "التراجع عن الحالة بالجملة",
  "merchants": "التجار",
  "platforms": "المنصات",
  "sync routes": "مزامنة المسارات",
  "advanced filters": "الفلاتر المتقدمة",
  "reverse": "إرجاع",
  "create manifest": "إنشاء بيان شحن",
  "manifest id": "رقم بيان الشحن",
  "shipments": "الشحنات",
  "view details": "عرض التفاصيل",
  "close sidebar": "إغلاق الشريط الجانبي",
  "select shipping carrier (3pl)": "اختر شركة شحن خارجية (3PL)",
  "select 3pl company...": "اختر شركة شحن خارجية (3PL)...",
  "choose a 3pl company to start manifesting shipments": "اختر شركة شحن خارجية (3PL) للبدء في إنشاء بيانات الشحن",
  "select a 3pl company above to unlock scan & load options": "اختر شركة شحن خارجية (3PL) أعلاه لإلغاء قفل خيارات المسح والتحميل",
  "scan & paste": "المسح واللصق",
  "load packed": "تحميل الشحنات المعبأة",
  "please select either scan & paste or load packed mode to continue.": "يرجى تحديد وضع المسح واللصق أو وضع تحميل المعبأ للمتابعة.",
  "scan or paste awbs here...": "امسح أو الصق أرقام بوالص الشحن هنا...",
  "scan next awb...": "امسح بوليصة الشحن التالية...",
  "clear all awbs": "مسح جميع أرقام بوالص الشحن",
  "generate manifest": "إنشاء بيان الشحن",
  "fetching packed shipments...": "جاري جلب الشحنات المعبأة...",
  "no packed shipments found": "لم يتم العثور على شحنات معبأة",
  "all shipments for": "جميع الشحنات لـ",
  "have been dispatched or are pending.": "تم إرسالها أو أنها معلقة.",
  "found": "تم العثور على",
  "packed shipment(s)": "شحنة (شحنات) معبأة",
  "deselect all": "إلغاء تحديد الكل",
  "client name": "اسم العميل",
  "e.g. obp100000066": "مثال: OBP100000066",
  "e.g. ts-blk-m": "مثال: TS-BLK-M",
  "packaging workstation": "محطة التعبئة والتغليف",
  "select dock station": "اختر منصة التحميل",
  "dock station": "محطة التحميل",
  "add dock station": "إضافة محطة تحميل",
  "edit dock station": "تعديل محطة تحميل",
  "dock station name": "اسم محطة التحميل",
  "enter dock station name": "أدخل اسم محطة التحميل",
  "dock station added successfully ✅": "تمت إضافة محطة التحميل بنجاح ✅",
  "dock station updated successfully ✅": "تم تحديث محطة التحميل بنجاح ✅",
  "dock station deleted successfully ✅": "تم حذف محطة التحميل بنجاح ✅",
  "1. scan awb / consignment no": "1. امسح بوليصة الشحن / رقم الشحنة",
  "2. scan item sku": "2. امسح رمز SKU للمنتج",
  "scan qty": "كمية المسح",
  "verify": "التحقق",
  "status: packed": "الحالة: تم التعبئة",
  "status: damage / issue": "الحالة: تلف / مشكلة",
  "carrier": "الناقل",
  "dest": "الوجهة",
  "print shipping label": "طباعة ملصق الشحن",
  "issue": "المشكلة",
  "instant scan all": "فحص جميع العناصر دفعة واحدة",
  "no active shipment loaded": "لم يتم تحميل أي شحنة نشطة",
  "please scan a consignment/awb barcode": "يرجى مسح باركود الشحنة/بوليصة الشحن",
  "workstation checklist": "قائمة التحقق الخاصة بمحطة العمل",
  "no items loaded": "لم يتم تحميل أي عناصر",
  "please scan an order awb to begin checklist": "يرجى مسح بوليصة شحن الطلب لبدء قائمة التحقق",
  "name (wt)": "الاسم (الوزن)",
  "qty verified": "الكمية المتحقق منها",
  "wt": "الوزن",
  "scale integration (digital live)": "الربط المباشر مع الميزان الرقمي",
  "measured mass": "الكتلة المقاسة",
  "stable": "مستقر",
  "1. selected packaging box type": "1. نوع صندوق التعبئة المختار",
  "select box type": "اختر نوع الصندوق",
  "no box / do not apply": "بدون صندوق / لا ينطبق",
  "volumetric box suggestion": "اقتراح الصندوق الحجمي",
  "qty needed": "الكمية المطلوبة",
  "box(es)": "صندوق (صناديق)",
  "no matching box suggested.": "لا يوجد اقتراح لصندوق مطابق.",
  "completed packed stream": "تدفق التعبئة المكتملة",
  "packed by": "تم التعبئة بواسطة",
  "all option": "كل الخيارات",
  "no packages packed today yet.": "لم يتم تعبئة أي طرود اليوم بعد.",
  "box": "الصندوق",
  "actual weight": "الوزن الفعلي",
  "confirm instant scan all": "تأكيد فحص جميع العناصر دفعة واحدة",
  "are you sure you want to instantly verify and pack all items in this order?": "هل أنت متأكد من أنك تريد التحقق وتعبئة جميع العناصر في هذا الطلب فوراً؟",
  "confirm & pack": "تأكيد وتعبئة",
  "packing...": "جاري التعبئة...",
  "online": "متصل",
  "dock 1": "الرصيف 1",
  "dock 2": "الرصيف 2",
  "dock 3": "الرصيف 3",
  "select merchant": "اختر التاجر",
  "payment type": "طريقة الدفع",
  "use": "استخدام",
  "address is required": "العنوان مطلوب",
  "select district": "اختر الحي",
  "select payment type": "اختر طريقة الدفع",
  "select service": "اختر الخدمة",
  "select shipment type": "اختر نوع الشحنة",
  "e.g. downtown dubai": "مثال: وسط مدينة دبي",
  "e.g. kuwait city": "مثال: مدينة الكويت",
  "e.g. doha": "مثال: الدوحة",
  "e.g. manama": "مثال: المنامة",
  "e.g. riyadh": "مثال: الرياض",
  "e.g. city": "مثال: المدينة",
  "e.g. district": "مثال: الحي",
  "search": "بحث",
  "send from different address": "إرسال من عنوان مختلف",
  "9-10 digits": "٩-١٠ أرقام",
  "cannot be all zeros": "لا يمكن أن يكون كله أصفاراً",
  "receiver country is required": "بلد المستلم مطلوب",
  "receiver name is required": "اسم المستلم مطلوب",
  "receiver email is required": "البريد الإلكتروني للمستلم مطلوب",
  "must include at least one letter": "يجب أن يحتوي على حرف واحد على الأقل",
  "9 or 10 digits": "٩ أو ١٠ أرقام",
  "click map or drag pin to auto-fill address": "انقر على الخريطة أو اسحب الدبوس لملء العنوان تلقائيًا",
  "loading map…": "جاري تحميل الخريطة...",
  "initializing google maps": "جاري تهيئة خرائط جوجل",
  "enter address or location": "أدخل العنوان أو الموقع",
  "my location": "موقعي",
  "selected location": "الموقع المحدد",
  "jan": "يناير",
  "feb": "فبراير",
  "mar": "مارس",
  "apr": "أبريل",
  "may": "مايو",
  "jun": "يونيو",
  "jul": "يوليو",
  "aug": "أغسطس",
  "sep": "سبتمبر",
  "oct": "أكتوبر",
  "nov": "نوفمبر",
  "dec": "ديسمبر",
  "admin": "مسؤول",
  "user": "مستخدم",
  "order created and stocks reserved": "تم إنشاء الطلب وحجز المخزون",
  "lm staff": "موظف الميل الأخير",
  "lm client": "عميل الميل الأخير",
  "client": "عميل",
  "driver": "سائق",
  "outlet": "منفذ",
  "fm": "الميل الأول",
  "lm": "الميل الأخير",
  "dist:": "الحي:",
  "saudi arabia": "المملكة العربية السعودية",
  "united arab emirates": "الإمارات العربية المتحدة",
  "kuwait": "الكويت",
  "qatar": "قطر",
  "bahrain": "البحرين",
  "oman": "عمان",
  "india": "الهند",
  "shipping details": "تفاصيل الشحنة",
  "forwarded company": "الشركة المحولة",
  "forwarded awb no": "رقم بوليصة الشحن المحولة",
  "kg": "كجم",
  "bullet delivery": "التوصيل السريع",
  "standard": "عادي",
  "sar": "ر.س",

  // ── Order Form / Preview section headings (not yet in dictionary) ──
  "sender information": "معلومات المرسل",
  "receiver information": "معلومات المستلم",
  "admin notes": "ملاحظات المسؤول",
  "select client": "اختيار العميل",
  "building name": "اسم المبنى",
  "building number": "رقم المبنى",
  "street name": "اسم الشارع",
  "zip code": "الرمز البريدي",
  "prepaid": "مدفوع مسبقاً",
  "postpaid": "الدفع عند الاستلام",
  "create": "إنشاء",
  "read": "قراءة",
  "edit": "تعديل",
  "update": "تحديث",
  "save": "حفظ",
  "view order": "عرض الطلب",
  "edit order": "تعديل الطلب",

  // ── Reverse Order form ──
  "awb number": "رقم بوليصة الشحن",
  "create reverse order": "إنشاء طلب إرجاع",
  "enter awb numbers (one per line)": "أدخل أرقام بوليصة الشحن (رقم واحد في كل سطر)",
  "enter awb number 1": "أدخل رقم بوليصة الشحن 1",
  "enter awb number 2": "أدخل رقم بوليصة الشحن 2",
  "submitting...": "جارٍ الإرسال...",

  // ── Bulk Order form ──
  "bulk order": "طلب مجمع",
  "order type": "نوع الطلب",
  "lm orders": "طلبات الميل الأخير",
  "fm orders": "طلبات الميل الأول",
  "upload lm excel/csv file": "رفع ملف Excel/CSV للميل الأخير",
  "upload fm excel/csv file": "رفع ملف Excel/CSV للميل الأول",
  "upload an excel or csv file (max size: 2 mb).": "رفع ملف Excel أو CSV (الحجم الأقصى: 2 ميغابايت).",
  "download the excel/csv template before uploading.": "قم بتنزيل نموذج Excel/CSV قبل الرفع.",
  "do not change column headers.": "لا تقم بتغيير عناوين الأعمدة.",
  "mandatory fields: client id, receiver, reference, weight, etc.": "الحقول الإلزامية: رقم العميل، المستلم، المرجع، الوزن، إلخ.",
  "note": "ملاحظة",
  "please upload the file in the same format as the downloaded file.": "يرجى رفع الملف بنفس تنسيق الملف الذي تم تنزيله.",
  "download": "تنزيل",
  "uploading...": "جارٍ الرفع...",

  // ── Order Action Sidebar ──
  "order actions": "إجراءات الطلب",
  "run bulk operations on awbs": "تنفيذ العمليات المجمعة على بوالص الشحن",
  "submit action": "تنفيذ الإجراء",
  "action type": "نوع الإجراء",
  "select action type": "اختر نوع الإجراء",
  "3pl forward": "تحويل إلى شركة شحن خارجية (3PL)",
  "3pl label print": "طباعة ملصق 3PL",
  "forward reverse": "تحويل عكسي",
  "status revert": "تراجع عن الحالة",
  "generate pickup": "إنشاء طلب استلام",
  "pdf generate": "إنشاء PDF",
  "3pl return": "إرجاع 3PL",
  "split order": "تقسيم الطلب",
  "cancel 3pl forward": "إلغاء تحويل 3PL",
  "status update": "تحديث الحالة",
  "configuration": "إعدادات",
  "3pl company": "شركة شحن خارجية (3PL)",
  "select 3pl": "اختر شركة شحن خارجية (3PL)",
  "3pl is required": "شركة شحن خارجية (3PL) مطلوبة",
  "select warehouse": "اختر المستودع",
  "warehouse is required": "المستودع مطلوب",
  "no. of pieces": "عدد القطع",
  "locked to 1 piece when multiple awbs are pasted.": "مغلق عند قطعة واحدة عند لصق بوالص متعددة.",
  "reason": "السبب",
  "reason is required": "السبب مطلوب",
  "enter reason": "أدخل السبب",
  "target status": "الحالة المستهدفة",
  "select status": "اختر الحالة",
  "status is required": "الحالة مطلوبة",
  "request type": "نوع الطلب",
  "select type": "اختر النوع",
  "single order picking": "التقاط الطلب المفرد",
  "batch picking": "الالتقاط الدفعي",
  "zone picking": "الالتقاط المنطقة",
  "process": "معالجة",
  "vehicle type": "نوع المركبة",
  "select vehicle": "اختر المركبة",
  "location": "الموقع",
  "select location": "اختر الموقع",
  "pickup date": "تاريخ الاستلام",
  "date is required": "التاريخ مطلوب",
  "time slot": "الفترة الزمنية",
  "pickup time": "وقت الاستلام",
  "time slot is required": "الفترة الزمنية مطلوبة",
  "this will generate bulk airway bills for the matching awbs specified above. click submit action in the header to render the document.": "سيؤدي هذا إلى إنشاء بوالص شحن مجمعة لبوالص الشحن المطابقة المحددة أعلاه. انقر على تنفيذ الإجراء في الرأس لعرض المستند.",
  "this will create a reverse order for the specified awbs. are you sure you want to proceed?": "سيؤدي هذا إلى إنشاء طلب إرجاع لبوالص الشحن المحددة. هل أنت متأكد أنك تريد المتابعة؟",
  "splitting is only allowed if exactly one awb is specified, and it has the status pending stock.": "يُسمح بالتقسيم فقط في حال تحديد بوليصة شحن واحدة بالضبط وبحالة 'بانتظار توفر المخزون'.",
  "paste awb / ref numbers": "لصق أرقام بوالص الشحن / المراجع",
  "awb": "بوليصة الشحن",
  "awbs": "بوالص الشحن",
  "orders selected in table": "طلبات محددة في الجدول",
  "sync selection": "مزامنة التحديد",
  "awb verification": "التحقق من بوليصة الشحن",
  "unmatched": "غير متطابق",
  "pickup": "الاستلام",
  "dropoff": "تسليم",
  "car": "سيارة",
  "van": "شاحنة صغيرة",
  "dokker": "دوكر",
  "select all": "تحديد الكل",
  "whatsapp": "واتساب",
  "pin location": "تحديد الموقع",
  "pin location on map": "تحديد الموقع على الخريطة",
  "pin warehouse location": "تحديد موقع المستودع",
  "street, building...": "الشارع، المبنى...",
  "street, building": "الشارع، المبنى",
  "pinned": "مثبت",
  "short address (national address)": "العنوان المختصر (العنوان الوطني)",
  "e.g. main street, area 51": "مثال: شارع رئيسي، منطقة 51",
  "must contain only digits": "يجب أن يحتوي على أرقام فقط",
  "company": "الشركة",
  "select company": "اختر الشركة",
  "select company first": "اختر الشركة أولاً",
  "loading types...": "جاري تحميل الأنواع...",
  "select year": "اختر السنة",
  "enter model manually": "أدخل النموذج يدويًا",
  "select model": "اختر النموذج",
  "loading models...": "جاري تحميل النماذج...",
  "select company/model first": "اختر الشركة/النموذج أولاً",
  "loading fuels...": "جاري تحميل أنواع الوقود...",
  "abc 1234 or 1234 abc": "أ ب ج ١٢٣٤ أو ١٢٣٤ أ ب ج",
  "e.g. 85000": "مثال: ٨٥٠٠٠",
  "1234567890": "١٢٣٤٥٦٧٨٩٠",
  "select from list": "اختر من القائمة",
  "enter manually": "أدخل يدويًا",
  "select manually": "حدد يدويًا",
  "vehicle name is required": "اسم المركبة مطلوب",
  "company is required": "الشركة مطلوبة",
  "vehicle type is required": "نوع المركبة مطلوب",
  "year is required": "السنة مطلوبة",
  "model is required": "النموذج مطلوب",
  "fuel type is required": "نوع الوقود مطلوب",
  "vehicle number is required": "رقم المركبة مطلوب",
  "vehicle number must be 3 letters and 1 to 4 digits (e.g. abc 1234 or 1234 abc)": "يجب أن يتكون رقم المركبة من ٣ حروف ومن ١ إلى ٤ أرقام (مثل: أ ب ج ١٢٣٤)",
  "odometer is required": "قراءة العداد مطلوبة",
  "odometer cannot be negative": "لا يمكن أن يكون عداد المسافات سالبًا",
  "odometer value looks unrealistic": "قيمة عداد المسافات غير واقعية",
  "rc number is required": "رقم الاستمارة (RC) مطلوب",
  "rc number must be exactly 10 digits": "يجب أن يتكون رقم الاستمارة (RC) من ١٠ أرقام تمامًا",
  "rc doc": "مستند الاستمارة",
  "odometer": "عداد المسافات",
  "total logs": "إجمالي السجلات",
  "vehicle": "المركبة",
  "reported by": "أبلغ عنه بواسطة",
  "back to odometer": "العودة إلى عداد المسافات",
  "vehicle pictures": "صور المركبة",
  "upload up to 4 images (png/jpg, max 1mb each)": "تحميل ما يصل إلى ٤ صور (PNG/JPG، بحد أقصى ١ ميجابايت لكل منها)",
  "fuel type": "نوع الوقود",
  "no image available": "لا توجد صورة متاحة",
  "start km": "عداد البداية",
  "end km": "عداد النهاية",
  "odometer (km)": "عداد المسافات (كم)",
  "rc number": "رقم الاستمارة (RC)",
  "year": "السنة",
  "back to fuel logs": "العودة إلى سجلات الوقود",
  "refilled at": "تم إعادة التعبئة في",
  "station": "المحطة",
  "fuel slip preview": "معاينة إيصال الوقود",
  "usd": "USD",
  "diesel": "ديزل",
  "petrol": "بنزين",
  "electric": "كهربائي",
  "hybrid": "هجين",
  "cng": "غاز طبيعي مضغوط",
  "lpg": "غاز بترولي مسال",
  "hydrogen": "هيدروجين",
  "change requests": "طلبات التغيير",
  "no data found": "لم يتم العثور على بيانات",
  "try adjusting your filters or come back later.": "جرّب تعديل عوامل التصفية أو عد لاحقًا.",
  "change vehicle": "تغيير المركبة",
  "submitted by": "أُرسلت بواسطة",
  "date filed": "تاريخ التقديم",
  "view requests": "عرض الطلبات",
  "approved": "تمت الموافقة",
  "reject request": "رفض الطلب",
  "approve request": "الموافقة على الطلب",
  "changing...": "جاري التغيير...",
  "change": "تغيير",
  "medium urgency": "متوسط الأهمية",
  "change request submitted for {vehicle} assignment by driver {driver}.": "تم تقديم طلب تغيير لتخصيص المركبة {vehicle} بواسطة السائق {driver}.",
  "unknown driver": "سائق غير معروف",
  "vehicle current images": "صور المركبة الحالية",
  "upload up to {maxfiles} images (png/jpg, max 1mb each).": "تحميل ما يصل إلى {maxFiles} صور (PNG/JPG، بحد أقصى 1 ميجابايت لكل منها).",
  "you can upload a maximum of {maxfiles} files": "يمكنك تحميل بحد أقصى {maxFiles} ملفات",
  "file \"{filename}\" exceeds 1mb limit.": "الملف \"{fileName}\" يتجاوز الحد الأقصى 1 ميجابايت.",
  "only {formats} files are allowed": "يسمح فقط بملفات {formats}",
  "overview": "نظرة عامة",
  "pod media": "ملفات إثبات التسليم",
  "driver assigned": "السائق المعين",
  "driver name": "اسم السائق",
  "all statuses": "جميع الحالات",
  "assigned to staff": "تم التعيين للموظف",
  "reverted / new order": "طلب مرتجع / جديد",
  "uploads details": "تفاصيل المرفقات",
  "collapse": "طي",
  "expand": "توسيع",
  "product details": "تفاصيل المنتج",
  "select manifest type": "اختر نوع البيان",
  "choose a manifest type from the dropdown above to configure your new manifest details.": "اختر نوع البيان من القائمة المنسدلة أعلاه لتكوين تفاصيل البيان الجديد الخاص بك.",

  // Manifest Module
  "assign driver": "تعيين السائق",
  "change driver": "تغيير السائق",
  "update driver": "تحديث السائق",
  "pickup collect": "تم استلام الشحنة",
  "assign receiver": "تعيين المستلم",
  "inbound": "الوارد",
  "assign vehicle": "تعيين المركبة",
  "assign linehaul vehicle": "تعيين مركبة الخط",
  "upload doc": "رفع مستند",
  "upload document": "رفع المستند",
  "assign to staff": "تعيين للموظف",
  "assign inv staff": "تعيين موظف المخزون",
  "assign inventory staff": "تعيين موظف المخزون",
  "collect": "جمع",
  "assign": "تعيين",
  "check & verify": "فحص وتحقق",
  "edit verify qty": "تعديل الكمية المتحقق منها",
  "checked & verified": "تم الفحص والتحقق",
  "add inventory": "إضافة مخزون",
  "return details": "تفاصيل الإرجاع",
  "linehaul manifest": "بيان شحن النقل بين المراكز",
  "product": "المنتج",
  "time": "الوقت",
  "manifest": "بيان الشحن",
  "linehaul": "النقل بين المراكز",
  "return": "الإرجاع",
  "load order": "تحميل الطلب",
  "paste awb": "لصق رقم بوليصة الشحن",
  "loading more…": "تحميل المزيد...",
  "no more shipments": "لا توجد شحنات أخرى",
  "paste order ids here…": "الصق معرفات الطلبات هنا...",
  "paste order ids here, separated by new lines, commas, or tabs...": "الصق معرفات الطلبات هنا، مفصولة بأسطر جديدة أو فواصل أو علامات تبويب...",
  "paste or scan awb numbers (one per line)": "الصق أو امسح أرقام بوالص الشحن (واحدة في كل سطر)",
  "AWB already added": "بوليصة الشحن مضافة بالفعل",
  "All pasted AWBs are duplicates or already added": "جميع بوالص الشحن الملصقة مكررة أو مضافة بالفعل",
  "duplicate(s) skipped": "تم تخطي المكرر(ات)",
  "mode": "الوضع",
  "instructions": "التعليمات",
  "add shipment": "إضافة شحنة",
  "generate request": "إنشاء طلب",
  "origin hub": "مركز المنشأ",
  "destination hub": "مركز الوجهة",
  "route details": "تفاصيل المسار",
  "return setup": "إعداد الإرجاع",
  "pickup type": "نوع الاستلام",
  "shipment list": "قائمة الشحنات",
  "line haul": "النقل بين المراكز",

  // LinehaulRequestModal extras
  "container id": "معرف الحاوية",
  "seal no.": "رقم الختم",
  "pallet": "بليت",
  "bag": "حقيبة",

  // New Manifest Tab translations
  "air waybill": "بوليصة الشحن الجوي",
  "awb/item": "بوليصة الشحن/العنصر",
  "shipment manifest": "بيان الشحنة",
  "line haul manifest": "بيان شحن النقل بين المراكز",
  "product manifest": "بيان شحن المنتجات",
  "return manifest": "بيان شحن المرتجعات",
  "merchant delivery manifest": "بيان شحن تسليم التاجر",
  "assigned to driver": "تم التعيين للسائق",
  "assign to inventory staff": "تعيين لموظف المخزون",
  "verified": "تم التحقق",
  "closed": "مغلق",
  "checked": "تم الفحص",
  "manifest request": "طلب البيان",
  "export": "تصدير",
  "no associated waybills": "لا توجد بوالص شحن مرتبطة",
  "no raw physical shipments registered to this manifest file": "لا توجد شحنات فعلية مسجلة في ملف البيان هذا",
  "filter": "تصفية",
  "customer digital signature": "التوقيع الرقمي للعميل",
  "download signature": "تنزيل التوقيع",
  "no signature file uploaded": "لم يتم تحميل ملف التوقيع",
  "status: sign-off pending": "الحالة: في انتظار التوقيع",
  "cargo photo verification": "التحقق من صورة الشحنة",
  "download cargo photo": "تنزيل صورة الشحنة",
  "no cargo photo verification media available": "لا تتوفر وسائط التحقق من صورة الشحنة",
  "assigned documents (pod/verification)": "المستندات المعينة (ملفات إثبات التسليم/التحقق)",
  "driver license:": "رخصة القيادة:",
  "download document": "تنزيل المستند",
  "not uploaded": "لم يتم الرفع",
  "driver iqama doc:": "وثيقة إقامة السائق:",
  "vehicle registration doc:": "وثيقة تسجيل المركبة:",
  "proof of delivery verification photo": "صورة التحقق من إثبات التسليم",
  "download pod photo": "تنزيل صورة إثبات التسليم",
  "no pod media available": "لا تتوفر ملفات إثبات التسليم",
  "sku(product name)": "رمز التخزين التعريفي (اسم المنتج)",
  "no products found": "لم يتم العثور على منتجات",
  "waybills selected": "بوالص شحن محددة",
  "clear": "مسح",
  "collected": "تم الجمع",
  "client id": "معرف العميل",
  "select staff": "اختر الموظف",
  "inventry staff": "موظف المخزون",
  "assign staff (check & verify)": "تعيين موظف (الفحص والتحقق)",
  "assign staff (inventory staff)": "تعيين موظف (موظف المخزون)",
  "assigned check staff": "موظف الفحص المعين",
  "assigned inventory staff": "موظف المخزون المعين",
  "received qty": "الكمية المستلمة",
  "missing qty": "الكمية المفقودة",
  "damage qty": "الكمية التالفة",
  "admin reason": "سبب المسؤول",
  "client reason": "سبب العميل",
  "expiry date": "تاريخ الانتهاء",

  // ── WMS Inventory & Shelves translation keys ──
  "warehouse layout map": "خريطة تخطيط المستودع",
  "double-click elements for control options. click any bin, pallet, or shipment to view contents.": "انقر نقرًا مزدوجًا فوق العناصر لخيارات التحكم. انقر فوق أي حاوية أو طبلية أو شحنة لعرض المحتويات.",
  "empty": "فارغ",
  "archived": "مؤرشف",
  "occupied": "مشغول",
  "select a warehouse": "اختر مستودعًا",
  "please select a warehouse from the options above to view its layout and inventory.": "يرجى تحديد مستودع من الخيارات الموضحة أعلاه لعرض تخطيطه ومخزونه.",
  "select an area": "اختر منطقة",
  "please select an area from the options above to view its layout and inventory.": "يرجى تحديد منطقة من الخيارات الموضحة أعلاه لعرض تخطيطها ومخزونها.",
  "create zone & area": "إنشاء منطقة ونطاق",
  "you don't have any area yet. create one using the button above.": "ليس لديك أي منطقة بعد. أنشئ واحدة باستخدام الزر أعلاه.",
  "create area": "إنشاء منطقة",
  "(you do not have permission to create areas)": "(ليس لديك صلاحية لإنشاء مناطق)",
  "add rows": "إضافة صفوف",
  "you don't have any rows yet. create one.": "ليس لديك أي صفوف بعد. أنشئ صفاً.",
  "racks": "رفوف",
  "active racks": "رفوف نشطة",
  "add more pallets": "إضافة طبالي إضافية",
  "create pallet": "إنشاء طبلية",
  "confirm archive": "تأكيد الأرشفة",
  "confirm restore": "تأكيد الاستعادة",
  "archive row?": "أرشفة الصف؟",
  "reactivate row?": "إعادة تفعيل الصف؟",
  "hide this row and its contents from daily operations.": "إخفاء هذا الصف ومحتوياته من العمليات اليومية.",
  "return this row to active daily operations.": "إعادة هذا الصف إلى العمليات اليومية النشطة.",
  "archive floor area?": "أرشفة مساحة الأرضية؟",
  "reactivate floor area?": "إعادة تفعيل مساحة الأرضية؟",
  "hide this floor area and its contents from daily operations.": "إخفاء مساحة الأرضية ومحتوياتها من العمليات اليومية.",
  "return this floor area to active daily operations.": "إعادة مساحة الأرضية إلى العمليات اليومية النشطة.",
  "archive rack?": "أرشفة الرف؟",
  "reactivate rack?": "إعادة تفعيل الرف؟",
  "hide this rack and its contents from daily operations.": "إخفاء هذا الرف ومحتوياته من العمليات اليومية.",
  "return this rack to active daily operations.": "إعادة هذا الرف إلى العمليات اليومية النشطة.",
  "archive level?": "أرشفة المستوى؟",
  "reactivate level?": "إعادة تفعيل المستوى؟",
  "hide this level and its contents from daily operations.": "إخفاء هذا المستوى ومحتوياته من العمليات اليومية.",
  "return this level to active daily operations.": "إعادة هذا المستوى إلى العمليات اليومية النشطة.",
  "location control panel": "لوحة التحكم بالموقع",
  "location path": "مسار الموقع",
  "shipment inventory": "مخزون الشحنات",
  "capacity & allocation": "السعة والتخصيص",
  "capacity cap": "الحد الأقصى للسعة",
  "reserved units": "الوحدات المحجوزة",
  "available units": "الوحدات المتاحة",
  "inventory traceability": "تتبع المخزون",
  "expiry": "تاريخ الانتهاء",
  "no barcode": "لا يوجد باركود",
  "no sku barcode": "لا يوجد باركود للمنتج",
  "print label": "طباعة الملصق",
  "archive": "أرشفة",
  "restore": "استعادة",
  "operational quick actions": "الإجراءات التشغيلية السريعة",
  "add levels": "إضافة مستويات",
  "edit name": "تعديل الاسم",
  "rack level": "مستوى الرف",
  "floor": "الأرضية",
  "all locations": "جميع المواقع",
  "beta": "تجريبي",
  "search locations, products...": "البحث عن المواقع، المنتجات...",
  "add location": "إضافة موقع",
  "export data": "تصدير البيانات",
  "received": "المستلمة",
  "reserved": "المحجوزة",
  "item inventory": "مخزون المواد",
  "inventory check": "جرد المخزون",
  "inventory": "المخزون",
  "reference id": "الرقم المرجعي",
  "location id": "معرف الموقع",
  "update inventory": "تحديث المخزون",
  "item type": "نوع العنصر",
  "bin location": "موقع الحاوية",
  "storage type": "نوع التخزين",
  "capacity": "السعة",
  "avl. qty.": "الكمية المتاحة",
  "inventory type": "نوع المخزون",
  "last updated": "آخر تحديث",
  "expiry status": "حالة الصلاحية",
  "expired": "منتهي الصلاحية",
  "no expiry": "بدون تاريخ انتهاء",
  "expires in": "ينتهي في",
  "hours": "ساعة",
  "days": "يوم",
  "reset shelf": "إعادة ضبط الرف",
  "scan / paste shelve barcode": "امسح أو الصق باركود الرف",
  "delete inventory shipment confirmation!": "تأكيد حذف شحنة المخزون!",
  "are you sure you want to perform this action?": "هل أنت متأكد أنك تريد تنفيذ هذا الإجراء؟",
  "update shipment inventory confirmation!": "تأكيد تحديث شحنة المخزون!",
  "are you sure you want to add shipment in given location": "هل أنت متأكد أنك تريد إضافة الشحنة في الموقع المحدد",
  "match": "مطابقة",
  "matched": "متطابق",
  "shelf id": "معرف الرف",
  "archive bin?": "أرشفة الحاوية؟",
  "reactivate bin?": "إعادة تفعيل الحاوية؟",
  "archive pallet?": "أرشفة الطبلية؟",
  "reactivate pallet?": "إعادة تفعيل الطبلية؟",
  "hide this bin and its contents from daily operations.": "إخفاء هذه الحاوية ومحتوياتها من العمليات اليومية.",
  "return this bin to active daily operations.": "إعادة هذه الحاوية إلى العمليات اليومية النشطة.",
  "hide this pallet and its contents from daily operations.": "إخفاء هذه الطبلية ومحتوياتها من العمليات اليومية.",
  "return this pallet to active daily operations.": "إعادة هذه الطبلية إلى العمليات اليومية النشطة.",
  "bin archived successfully": "تم أرشفة الحاوية بنجاح",
  "bin restored successfully": "تم استعادة الحاوية بنجاح",
  "pallet archived successfully": "تم أرشفة الطبلية بنجاح",
  "pallet restored successfully": "تم استعادة الطبلية بنجاح",
  "rack row": "صف الرفوف",
  "rack actions": "إجراءات الرف",
  "row actions": "إجراءات الصف",
  "floor actions": "إجراءات الأرضية",
  "level actions": "إجراءات المستوى",
  "create bin": "إنشاء حاوية",
  "add more bins": "إضافة حاويات إضافية",
  "cannot archive rack with active inventory": "لا يمكن أرشفة الرف مع وجود مخزون نشط",
  "cannot archive row with active inventory": "لا يمكن أرشفة الصف مع وجود مخزون نشط",
  "cannot archive floor with active inventory": "لا يمكن أرشفة مساحة الأرضية مع وجود مخزون نشط",
  "cannot archive level with active inventory": "لا يمكن أرشفة المستوى مع وجود مخزون نشط",
  "items stored": "عناصر مخزنة",
  "items across": "عناصر عبر",
  "levels": "مستويات",
  "add floor storage": "إضافة مساحة تخزين أرضية",
  "create floor storage in": "إنشاء مساحة تخزين أرضية في",
  "cannot archive with inventory": "لا يمكن الأرشفة مع وجود مخزون",
  "full": "ممتلئ",
  "sn": "#",
  "you do not have permission to update items.": "ليس لديك صلاحية لتحديث المواد.",
  "status updated successfully": "تم تحديث الحالة بنجاح",
  "you do not have permission to update outlet status": "ليس لديك صلاحية لتحديث حالة المنفذ",
  "outlet updated successfully": "تم تحديث المنفذ بنجاح",
  "outlet created successfully": "تم إنشاء المنفذ بنجاح",
  "failed to update status": "فشل في تحديث الحالة",
  "failed to update outlet": "فشل في تحديث المنفذ",
  "failed to create outlet": "فشل في إنشاء المنفذ",
  "location type": "نوع الموقع",
  "qty.": "الكمية",
  "no data available to export": "لا توجد بيانات متاحة للتصدير",
  "exported successfully!": "تم التصدير بنجاح!",
  "movement type": "نوع الحركة",
  "outbound": "الصادر",
  "reservation": "حجز",
  "unpaid": "غير مدفوع",
  "invoice type": "نوع الفاتورة",
  "invoice lists": "قوائم الفواتير",
  "pay adjust": "تعديل الدفع",
  "generate invoice": "إنشاء فاتورة",
  "add invoice": "إضافة فاتورة",
  "downloading....": "جاري التحميل...",
  "invoices": "الفواتير",
  "you do not have permission to create invoices": "ليس لديك صلاحية لإنشاء الفواتير",
  "vehicle added successfully.": "تم إضافة المركبة بنجاح.",
  "receive date": "تاريخ الاستلام",
  "response": "الرد",
  "quotation": "عرض سعر",
  "approve": "مقبول",
  "request id": "معرف الطلب",
  "linehaul requests": "طلبات النقل بين المراكز",
  "view invoice": "عرض الفاتورة",
  "customer": "العميل",
  "due date": "تاريخ الاستحقاق",
  "export pdf": "تصدير PDF",
  "enter transition number": "أدخل رقم العملية",
  "upload images": "تحميل الصور",
  "you can upload pdf , png or jpg format only.": "يمكنك تحميل ملفات بصيغة PDF أو PNG أو JPG فقط.",
  "select information": "اختر المعلومات",
  "select invoices type": "اختر نوع الفاتورة",
  "select paymenttype": "اختر نوع الدفع",
  "scan to add": "امسح للإضافة",
  "scan shipment assign orders": "امسح الشحنة لتعيين الطلبات",
  "entry date is required": "تاريخ الدخول مطلوب",
  "close date is required": "تاريخ الإغلاق مطلوب",
  "bulk scan": "مسح جماعي",
  "cod invoice": "فاتورة الدفع عند الاستلام",
  "payable invoice": "فاتورة مستحقة الدفع",
  "create warehouse": "إنشاء مستودع",
  "edit warehouse": "تعديل المستودع",
  "warehouse name": "اسم المستودع",
  "linehaul request": "طلب النقل بين المراكز",
  "request info": "معلومات الطلب",
  "creator": "المنشئ",
  "requested date": "تاريخ الطلب",
  "companies quotation": "عروض أسعار الشركات",
  "approving...": "جاري الموافقة...",
  "you do not have permission to approve linehaul request": "ليس لديك صلاحية للموافقة على طلب النقل بين المراكز",
  "linehaul request generated successfully": "تم إنشاء طلب النقل بنجاح",
  "shelf verified!": "تم التحقق من الرف!",
  "invalid shelf barcode": "رمز باركود الرف غير صالح",
  "awb scanned": "تم مسح بوليصة الشحن",
  "verify shelf first": "يرجى التحقق من الرف أولاً",
  "awb(s) pasted": "بوليصة/بولايص شحن تم لصقها",
  "scan, paste, or type shelf id...": "امسح أو الصق أو اكتب معرف الرف...",
  "verifying shelf...": "جاري التحقق من الرف...",
  "paste awbs, scan them, or type...": "الصق بوليصات الشحن، أو امسحها، أو اكتب...",
  "scan shelf first": "امسح الرف أولاً",
  "avl. qty": "الكمية المتاحة",
  "failed to process barcode": "فشل في معالجة الرمز الشريطي",
  "you do not have permission to update shipment inventory.": "ليس لديك صلاحية لتحديث مخزون الشحنات.",
  "you do not have permission to delete shipment inventory.": "ليس لديك صلاحية لحذف مخزون الشحنات.",
  "unmatched shipment deleted successfully!": "تم حذف الشحنة غير المطابقة بنجاح!",
  "failed to delete shipment": "فشل في حذف الشحنة",
  "you do not have permission to create shipment inventory.": "ليس لديك صلاحية لإنشاء مخزون الشحنات.",
  "shipment inventory added successfully": "تم إضافة مخزون الشحنات بنجاح",
  "inventory check (shelve:": "فحص المخزون (الرف:",
  "dist": "المنطقة",
  "location set": "تم تعيين الموقع",
  "heatmap": "خريطة الحرارة",
  "floor name": "اسم الطابق",
  "number of slots": "عدد الأماكن",
  "slots": "أماكن",
  "select row": "اختر الصف",
  "create floor without row association": "إنشاء طابق بدون ربط صف",
  "select rack": "اختر الرف",
  "position": "الموضع",
  "select position": "اختر الموضع",
  "start": "البداية",
  "end": "النهاية",
  "auto-set": "تعيين تلقائي",
  "only": "فقط",
  "generating location ids": "معرفات المواقع المولّدة",
  "place the floor at start or end of the selected rack.": "ضع الطابق في بداية أو نهاية الرف المحدد.",
  "selecting a rack is required because the row floor is already occupied/blocked.": "يجب اختيار رف لأن طابق الصف محجوز/مشغول.",
  "floor slots created": "أماكن طابق تم إنشاؤها",
  "row archived successfully": "تم أرشفة الصف بنجاح",
  "row restored successfully": "تم استعادة الصف بنجاح",
  "failed to archive": "فشل في الأرشفة",
  "failed to restore": "فشل في الاستعادة",
  "floor archived successfully": "تم أرشفة منطقة الأرضية بنجاح",
  "floor restored successfully": "تم استعادة منطقة الأرضية بنجاح",
  "row name updated successfully": "تم تحديث اسم الصف بنجاح",
  "failed to update row name": "فشل في تحديث اسم الصف",
  "failed to": "فشل في",
  "row": "الصف",
  "create row": "إنشاء صف",
  "edit row": "تعديل الصف",
  "enter name": "أدخل الاسم",
  "row prefix is required": "بادئة الصف مطلوبة",
  "row prefix must be at least 2 characters": "يجب أن تتكون بادئة الصف من حرفين على الأقل",
  "row prefix must be 3 characters or less": "يجب أن تكون بادئة الصف 3 أحرف أو أقل",
  "row number is required": "رقم الصف مطلوب",
  "zone / area setup": "إعداد الزون / المنطقة",
  "name must be at least 2 characters long": "يجب أن يتكون الاسم من حرفين على الأقل",
  "name must not exceed 3 characters": "يجب ألا يتجاوز الاسم 3 أحرف",
  "add pallet locations": "إضافة مواقع الطبالي",
  "pallet prefix": "بادئة الطبلية",
  "preview location labels": "معاينة تسميات المواقع",
  "confirm & add": "تأكيد وإضافة",
  "1 pallets": "طبلية 1",
  "2 pallets": "طبلية 2",
  "3 pallets": "طبلية 3",
  "4 pallets": "طبلية 4",
  "5 pallets": "طبلية 5",
  "10 pallets": "طبلية 10",
  "20 pallets": "طبلية 20",
  "select...": "تحديد...",
  "...select": "تحديد...",
  "select level": "اختر المستوى",
  "add bins": "إضافة صناديق",
  "add pallets": "إضافة طبالي",
  "add bins / pallet": "إضافة صناديق / طبلية",
  "bins": "صناديق",
  "pallets": "طبالي",
  "required (e.g., p)": "مطلوب (مثال: P)",
  "max 3 characters": "3 أحرف كحد أقصى",
  "e.g. p": "مثال: P",
  "select rack level": "اختر مستوى الرف",
  "bin type is required": "نوع الصندوق مطلوب",
  "bin number is required": "رقم الصندوق مطلوب",
  "bins updated successfully!": "تم تحديث الصناديق بنجاح!",
  "bins created successfully!": "تم إنشاء الصناديق بنجاح!",
  "pallets updated successfully!": "تم تحديث الطبالي بنجاح!",
  "pallets created successfully!": "تم إنشاء الطبالي بنجاح!",
  "please select a rack level.": "يرجى تحديد مستوى الرف.",
  "pallet(s) updated successfully": "تم تحديث الطبالي بنجاح!",
  "pallet(s) added successfully": "تم إضافة الطبالي بنجاح!",
  "creation failed": "فشل الإنشاء",
  "saving...": "جاري الحفظ...",
  "rack": "رف",
  "level": "مستوى",
  "rack / level": "الرف / المستوى",
  "create rack / level": "إنشاء رف / مستوى",
  "edit rack / level": "تعديل رف / مستوى",
  "rack prefix is required": "بادئة الرف مطلوبة",
  "rack prefix must be at least 2 characters": "يجب أن تتكون بادئة الرف من حرفين على الأقل",
  "rack prefix must be 3 characters or less": "يجب أن تكون بادئة الرف 3 أحرف أو أقل",
  "rack number is required": "رقم الرف مطلوب",
  "level prefix is required": "بادئة المستوى مطلوبة",
  "level prefix must be at least 2 characters": "يجب أن تتكون بادئة المستوى من حرفين على الأقل",
  "level prefix must be 3 characters or less": "يجب أن تكون بادئة المستوى 3 أحرف أو أقل",
  "level number is required": "رقم المستوى مطلوب",
  "edit row name": "تعديل اسم الصف",
  "update the name of this row": "تحديث اسم هذا الصف",
  "row name": "اسم الصف",
  "enter row name": "أدخل اسم الصف",
  "maximum 3 characters": "3 أحرف كحد أقصى",
  "category": "الفئة",
  "storage": "التخزين",
  "hs code": "رمز HS",
  "dimensions": "الأبعاد",
  "created at": "تاريخ الإنشاء",
  "active:": "نشط:",
  "categories:": "الفئات:",
  "capacity:": "السعة:",
  "variants": "الخيارات",
  "promotions": "العروض الترويجية",
  "terms & conditions": "الشروط والأحكام",
  "promo sku": "رمز SKU الترويجي",
  "allocated qty": "الكمية المخصصة",
  "duration": "المدة",
  "action": "الإجراء",
  "colour": "اللون",
  "sku / code": "رمز SKU / الكود",
  "policy content": "محتوى السياسة",
  "bin": "صندوق",
  "rtf": "مرتجع",
  "variants not enabled for this sku hierarchy.": "المتغيرات غير مفعلة لهذا الهيكل من SKU.",
  "no active promotions for this product.": "لا توجد عروض ترويجية نشطة لهذا المنتج.",
  "no terms and conditions configured for this product.": "لم يتم إعداد شروط وأحكام لهذا المنتج.",
  "iphone": "آيفون",
  "search products...": "البحث عن المنتجات...",
  "product info": "معلومات المنتج",
  "fetch": "جلب",
  "products": "منتجات",
  "no category": "لا توجد فئة",
  "exists": "موجود",
  "new": "جديد",
  "bundle": "حزمة",
  "parent": "أب",
  "simple": "بسيط",
  "select entire product (no options or consisted products)": "تحديد المنتج بالكامل (لا توجد خيارات أو منتجات مكونة)",
  "this product has no configurable options or consisted products.": "هذا المنتج لا يحتوي على خيارات قابلة للتكوين أو منتجات مكونة.",
  "add promo": "إضافة عرض ترويجي",
  "view promo": "عرض الترويجي",
  "edit promo": "تعديل الترويجي",
  "promo": "العرض الترويجي",
  "product media": "وسائط المنتج",
  "live app": "تطبيق حي",
  "dangerous goods": "بضائع خطرة",
  "t&c": "الشروط والأحكام",
  "basic information": "معلومات أساسية",
  "product name": "اسم المنتج",
  "select category": "اختر الفئة",
  "category first": "الفئة أولاً",
  "compliance": "الامتثال",
  "commodity": "السلعة",
  "import commodity": "سلعة استيراد",
  "dimensions & weight": "الأبعاد والوزن",
  "length": "الطول",
  "width": "العرض",
  "height": "الارتفاع",
  "pricing & copywriting details": "تفاصيل التسعير والوصف",
  "min order": "الحد الأدنى للطلب",
  "short description": "وصف قصير",
  "long description": "وصف تفصيلي",
  "viewing in read-only mode. click \"edit item\" at the top to make modifications.": "العرض في وضع القراءة فقط. انقر على \"تعديل العنصر\" في الأعلى لإجراء تعديلات.",
  "clear variant data?": "مسح بيانات المتغير؟",
  "turning off variants will delete all sku, price, and image data you've entered for these options.": "سيؤدي إيقاف تشغيل المتغيرات إلى حذف جميع بيانات SKU والسعر والصورة التي أدخلتها لهذه الخيارات.",
  "value": "القيمة",
  "bulk upload items": "تحميل العناصر بالجملة",
  "upload excel file": "تحميل ملف إكسل",
  "upload a csv or excel file only (max size: 2 mb).": "تحميل ملف CSV أو Excel فقط (الحد الأقصى للحجم: 2 ميجابايت).",
  "download the excel template before uploading.": "قم بتنزيل قالب Excel قبل التحميل.",
  "do not change column headers or structure.": "لا تقم بتغيير رؤوس الأعمدة أو هيكلها.",
  "all fields are required except for discount and product tags.": "جميع الحقول مطلوبة باستثناء الخصم وعلامات المنتج.",
  "ensure category and sub category names exist in your database.": "تأكد من وجود أسماء الفئات والفئات الفرعية في قاعدة البيانات الخاصة بك.",
  ": please upload the file in the same format as the downloaded template file.": ": يرجى تحميل الملف بنفس تنسيق ملف القالب الذي تم تنزيله.",
  "download template": "تنزيل القالب",
  "successfully uploaded": "تم التحميل بنجاح",
  "failed records": "السجلات الفاشلة",
  "error reason": "سبب الخطأ",
  "attention:": "تنبيه:",
  "records that failed to upload. download the excel sheet, resolve the highlighted red errors, and re-upload.": "سجلات فشل تحميلها. قم بتنزيل ورقة Excel، وحل الأخطاء المميزة باللون الأحمر، وأعد التحميل.",
  "download failed data": "تنزيل البيانات الفاشلة",
  "create promo": "إنشاء عرض ترويجي",
  "edit item": "تعديل العنصر",
  "view item": "عرض العنصر",
  "create & configure advanced item": "إنشاء وتكوين عنصر متقدم",
  "assemble catalog information, dimension specifications, variant attributes, and synchronization channels seamlessly.": "تجميع معلومات الكتالوج ومواصفات الأبعاد وخصائص المتغيرات وقنوات المزامنة بسلاسة.",
  "add item": "إضافة عنصر",
  "sub category": "الفئة الفرعية",
  "cost price": "سعر التكلفة",
  "minimum quantity": "الحد الأدنى للكمية",
  "images & 1 video max 3": "3 صور وفيديو واحد كحد أقصى",
  "drag & drop to upload": "اسحب وأفلت للتحميل",
  "3 images & 1 video max": "3 صور وفيديو واحد كحد أقصى",
  "maximum 2 storage entries allowed": "مسموح بمدخلي تخزين كحد أقصى",
  "add storage entry": "إضافة مدخل تخزين",
  "no storage configurations added yet": "لم يتم إضافة تكوينات تخزين بعد",
  "storage type is required": "نوع التخزين مطلوب",
  "capacity is required": "السعة مطلوبة",
  "capacity must be a number": "يجب أن تكون السعة رقماً",
  "minimum quantity is required": "الحد الأدنى للكمية مطلوب",
  "remove this storage entry": "إزالة مدخل التخزين هذا",
  "failed to add item.": "فشل في إضافة العنصر.",
  "item name is required": "اسم العنصر مطلوب",
  "product name should not contain special characters": "يجب ألا يحتوي اسم المنتج على رموز خاصة",
  "sku is required": "رمز التخزين (SKU) مطلوب",
  "category is required": "الفئة مطلوبة",
  "sub category is required": "الفئة الفرعية مطلوبة",
  "commodity is required": "السلعة مطلوبة",
  "import commodity is required": "سلعة الاستيراد مطلوبة",
  "hs code is required": "رمز HS مطلوب",
  "length is required": "الطول مطلوب",
  "width is required": "العرض مطلوب",
  "height is required": "الارتفاع مطلوب",
  "weight is required": "الوزن مطلوب",
  "price is required": "السعر مطلوب",
  "minimum order is required": "الحد الأدنى للطلب مطلوب",
  "short description is required": "الوصف القصير مطلوب",
  "long description is required": "الوصف التفصيلي مطلوب",
  "sku cannot start with special characters": "لا يمكن أن يبدأ رمز SKU برموز خاصة",
  "drs id": "رقم بيان الاستلام",
  "drs settlement": "تسوية بيان الاستلام",
  "settle full cod": "تسوية الدفع عند الاستلام بالكامل",
  "shipment & order summary": "ملخص الشحنة والطلب",
  "cod shipments:": "شحنات الدفع عند الاستلام:",
  "ofd": "خارج للتوصيل",
  "pod": "تم التوصيل",
  "nd": "لم يتم التوصيل",
  "rtw": "تم الاستلام في المستودع",
  "driver financials": "البيانات المالية للسائق",
  "digital (card)": "رقمي (بطاقة)",
  "cash": "نقداً",
  "collection history": "سجل التحصيل",
  "collected by": "حصلت بواسطة",
  "amount": "المبلغ",
  "reconciliation status": "حالة المطابقة",
  "cash settlement desk": "مكتب تسوية النقدية",
  "collected amount": "المبلغ المحصل",
  "wallet balance": "رصيد المحفظة",
  "expected cod": "الدفع عند الاستلام المتوقع",
  "expected": "المتوقع",
  "difference": "الفرق",
  "wallet balance & difference": "رصيد المحفظة والفرق",
  "ready to settle": "جاهز للتسوية",
  "pending shipments": "الشحنات المعلقة",
  "driver wallet balance is low": "رصيد محفظة السائق منخفض",
  "settle partial cod": "تسوية الدفع عند الاستلام الجزئي",
  "enter amount to collect": "أدخل المبلغ المراد تحصيله",
  "collect partial": "تحصيل جزئي",
  "collecting...": "جاري التحصيل...",
  "delivering...": "جاري التوصيل...",
  "settled": "تمت التسوية",
  "unsettled": "غير مسوى",
  "partially settled": "مسوى جزئياً",
  "eligible (riw ok)": "مؤهل (تم الاستلام في المستودع)",
  "driver wallet": "محفظة السائق",
  "routeCode": "رمز المسار",
  "date & time": "التاريخ والوقت",
  "checkbox": "مربع تحديد",
  "create drs": "إنشاء بيان الاستلام",
  "select route": "اختر المسار",
  "select driver": "اختر السائق",
  "driver is required": "السائق مطلوب",
  "shipments list": "قائمة الشحنات",
  "fetching details...": "جاري جلب التفاصيل...",
  "please select warehouse, driver and set capacity before proceeding.": "يرجى اختيار المستودع، السائق وتحديد السعة قبل المتابعة.",
  "forward to 3pl": "إرسال إلى شركة شحن أخرى",
  "unknown": "غير معروف",
  "outlets management": "إدارة المنافذ",
  "loading outlets...": "جاري تحميل المنافذ...",
  "are you sure you want to deactivate this outlet?": "هل أنت متأكد أنك تريد إلغاء تنشيط هذا المنفذ؟",
  "are you sure you want to activate this outlet?": "هل أنت متأكد أنك تريد تنشيط هذا المنفذ؟",
  "edit outlet": "تعديل المنفذ",
  "add new outlet": "إضافة منفذ جديد",
  "outlet information": "معلومات المنفذ",
  "outlet name": "اسم المنفذ",
  "outlet mobile": "جوال المنفذ",
  "outlet address": "عنوان المنفذ",
  "looking up address…": "جاري البحث عن العنوان...",
  "full address line": "العنوان بالكامل",
  "outlet name is required": "اسم المنفذ مطلوب",
  "outlet name must contain only alphanumeric characters, spaces, and hyphens": "يجب أن يحتوي اسم المنفذ على أحرف وأرقام ومسافات وواصلات فقط",
  "outlet name cannot be empty or only spaces": "لا يمكن أن يكون اسم المنفذ فارغاً أو مسافات فقط",
  "invalid email address": "بريد إلكتروني غير صالح",
  "mobile is required": "رقم الجوال مطلوب",
  "short address is required": "العنوان المختصر مطلوب",
  "enter a valid 8-character short address": "أدخل عنواناً مختصراً صالحاً من 8 أحرف",
  "latitude must be a valid number": "يجب أن يكون خط العرض رقماً صالحاً",
  "latitude must be between -90 and 90": "يجب أن يكون خط العرض بين -90 و 90",
  "longitude must be a valid number": "يجب أن يكون خط الطول رقماً صالحاً",
  "longitude must be between -180 and 180": "يجب أن يكون خط الطول بين -180 و 180",
  "full address is required": "العنوان بالكامل مطلوب",
  "outlet details": "تفاصيل المنفذ",
  "add outlet": "إضافة منفذ",
  "code": "الرمز",
  "connect": "اتصال",
  "create date": "تاريخ الإنشاء",
  "create outlet": "إنشاء منفذ",
  "enter": "إدخال",
  "enter full address details": "أدخل تفاصيل العنوان الكامل",
  "loading credentials...": "جاري تحميل البيانات الاعتمادية...",
  "loading warehouses...": "جاري تحميل المستودعات...",
  "location details": "تفاصيل الموقع",
  "no": "لا",
  "no access to any section.": "لا يوجد وصول إلى أي قسم.",
  "yes": "نعم",
  "outlet code": "رمز المنفذ",
  "integration": "الربط الإلكتروني",
  "connected:": "المتصلة:",
  "request:": "الطلب:",
  "connect:": "الاتصال:",
  "real-time booking & waybills": "الحجز الفوري وبوالص الشحن",
  "request": "طلب",
  "install": "تثبيت",
  "connected": "متصل",
  "requested": "تم تقديم الطلب",
  "rejected": "مرفوض",
  "installed": "تم التثبيت",
  "idle": "خامل",
  "disconnect": "قطع الاتصال",
  "cancel request": "إلغاء الطلب",
  "are you sure you want to cancel request?": "هل أنت متأكد من أنك تريد إلغاء الطلب؟",
  "requesting...": "جاري الطلب...",
  "request integration": "طلب الربط الإلكتروني",
  "confirming...": "جاري التأكيد...",
  "test connection": "اختبار الاتصال",
  "submit credentials": "إرسال بيانات الاعتماد",
  "api access information": "معلومات الوصول لواجهة برمجة التطبيقات API",
  "webhook url": "رابط Webhook",
  "service code": "رمز الخدمة",
  "ispudo": "isPudo",
  "advance settings": "الإعدادات المتقدمة",
  "product movements": "حركات المنتجات",
  "order allocations": "تخصيص الطلبات",
  "current driver wallet:": "رصيد محفظة السائق الحالي:",
  "no cod collected by driver": "لم يتم تحصيل أي دفع عند الاستلام من قبل السائق",
  "driver has not collected any cod yet.": "السائق لم يجمع أي مبالغ دفع عند الاستلام بعد.",
  "driver wallet balance is less than cod.": "رصيد محفظة السائق أقل من مبلغ الدفع عند الاستلام.",
  "card payment details": "تفاصيل الدفع بالبطاقة",
  "total card amount": "إجمالي مبلغ البطاقة",
  "no card transaction details available.": "لا تتوفر تفاصيل عمليات البطاقة.",
  "select drs": "اختر بيان الاستلام",

  // Navigation menu items (missing from previous dictionary)
  "users": "المستخدمون",
  "invoice": "الفاتورة",
  "reports": "التقارير",
  "outlets": "المنافذ",
  "settings": "الإعدادات",

  // Profile dropdown items (missing from previous dictionary)
  "shipping config": "إعدادات الشحن",
  "help & support": "المساعدة والدعم",

  // Header notification panel
  "notifications": "الإشعارات",
  "no notifications": "لا توجد إشعارات",
  "show more": "عرض المزيد",

  // Search placeholder (NormalSearch component)
  "search here...": "ابحث هنا...",

  // Activity Logs JsonViewer copy button
  "copy json": "نسخ JSON",
  "copied!": "تم النسخ!",
  "failed to copy json": "فشل في نسخ JSON",

  // Help & Support / Chat Support keys
  "tickets support": "دعم التذاكر",
  "chat support": "دعم الدردشة",
  "gwarm support": "دعم جوارم",
  "support team • online": "فريق الدعم • متصل",
  "hello! how can we help you?": "مرحباً! كيف يمكننا مساعدتك؟",
  "👋 hello! how can we help you?": "👋 مرحباً! كيف يمكننا مساعدتك؟",
  "our support team is ready to assist with your shipments, account, billing, or any platform question.": "فريق الدعم لدينا مستعد لمساعدتك في شحناتك، حسابك، فواتيرك، أو أي سؤال حول المنصة.",
  "common questions": "الأسئلة الشائعة",
  "where is my order?": "أين طلبي؟",
  "i need help with my account": "أحتاج إلى مساعدة في حسابي",
  "subscription or billing question": "سؤال عن الاشتراك أو الفواتير",
  "fleet or delivery issue": "مشكلة في الأسطول أو التوصيل",
  "previous conversations": "المحادثات السابقة",
  "start a conversation": "بدء محادثة",
  "send a message to get started 👇": "أرسل رسالة للبدء 👇",
  "voice message": "رسالة صوتية",
  "type your message here...": "اكتب رسالتك هنا...",
  "chat with gwarm support": "الدردشة مع دعم جوارم",
  "preview unavailable": "المعاينة غير متاحة",
  "download the file to view it.": "قم بتنزيل الملف لعرضه.",
  "support staff": "موظف الدعم",
  "powered by": "مشغل بواسطة",
  "receiving": "الواردة",
  "unknown chat": "دردشة غير معروفة",
  "group chat": "دردشة جماعية",
  "direct chat": "دردشة مباشرة",
  "chats": "الدردشات",
  "new chat": "دردشة جديدة",
  "delete chat": "حذف الدردشة",
  "no active chats": "لا توجد دردشات نشطة",
  "no messages yet": "لا توجد رسائل بعد",
  "chat started": "بدأت الدردشة",
  "write a message...": "اكتب رسالة...",
  "recording...": "جاري التسجيل...",
  "stop": "إإيقاف",
  // Integration Tips keys
  "integration tips": "نصائح التكامل",
  "what this integration does:": "ماذا يفعل هذا التكامل:",
  "automatically fetches new orders from your shopify store.": "يجلب الطلبات الجديدة تلقائياً من متجر شوبيفاي الخاص بك.",
  "syncs shipping information and order status in real time.": "يزامن معلومات الشحن وحالة الطلب في الوقت الفعلي.",
  "generates shipping labels directly from your dashboard.": "يولد ملصقات الشحن مباشرة من لوحة التحكم الخاص بك.",
  "reduces manual work and speeds up fulfillment.": "يقلل العمل اليدوي ويسرع عملية تلبية الطلبات.",
  "permissions required:": "الأذونات المطلوبة:",
  "access to order details.": "الوصول إلى تفاصيل الطلب.",
  "access to customer shipping addresses.": "الوصول إلى عناوين شحن العملاء.",
  "permission to write back order tracking info.": "إذن لكتابة معلومات تتبع الطلب.",
  "what you’ll need to provide:": "ما ستحتاج إلى تقديمه:",
  "your shopify store url (e.g., myshop.myshopify.com).": "رابط متجر شوبيفاي الخاص بك (مثال: myshop.myshopify.com).",
  "access credentials or install the integration app.": "بيانات اعتماد الوصول أو تثبيت تطبيق التكامل.",
  "admin access to your store.": "وصول المسؤول إلى متجرك.",
  "please note:": "يرجى الملاحظة:",
  "approval may take 24–48 hours after your request.": "قد يستغرق الحصول على الموافقة من 24 إلى 48 ساعة بعد طلبك.",
  "you'll receive an email once the integration is activated.": "ستتلقى رسالة بريد إلكتروني بمجرد تنشيط التكامل.",
  "attachment": "مرفق",
  "click to preview": "انقر للمعاينة",
  "voice clip": "مقطع صوتي",
  "your conversations": "محادثاتك",
  "select a contact from the sidebar or click the new chat button to start messaging with your team.": "اختر جهة اتصال من الشريط الجانبي أو انقر فوق زر دردشة جديدة لبدء المراسلة مع فريقك.",
  "enter group name": "أدخل اسم المجموعة",
  "select participants": "اختر المشاركين",
  "search and select users...": "ابحث واختر المستخدمين...",
  "no contacts found": "لم يتم العثور على جهات اتصال",
  "create group": "إنشاء مجموعة",
  "start chat": "بدء الدردشة",
  "file preview unavailable": "معاينة الملف غير متاحة",
  "you can still download the file to view it.": "لا يزال بإمكانك تنزيل الملف لعرضه.",
  "download file": "تنزيل الملف",
  "please enter a group name": "الرجاء إدخال اسم المجموعة",
  "file size exceeds 2mb limit": "حجم الملف يتجاوز الحد المسموح به ٢ ميجابايت",
  "created tickets": "التذاكر المنشأة",
  "receiving tickets": "التذاكر الواردة",
  "loading tickets...": "جاري تحميل التذاكر...",
  "ticket id": "معرف التذكرة",
  "subject": "الموضوع",
  "create support ticket": "إنشاء تذكرة دعم",
  "sender": "المرسل",
  "are you sure you want to delete this chat?": "هل أنت متأكد أنك تريد حذف هذه الدردشة؟",
  "resolved": "تم الحل",
  "on hold": "قيد الانتظار",
  "reopened": "أعيد فتحها",
  "view ticket": "عرض التذكرة",
  "category type": "نوع الفئة",
  "assigned staff": "الموظف المعين",
  "ticket priority": "أولوية التذكرة",
  "detailed description": "الوصف التفصيلي",
  "attachments": "المرفقات",
  "communication": "التواصل",
  "activity log": "سجل النشاطات",
  "no comments yet": "لا توجد تعليقات بعد",
  "add reply": "إضافة رد",
  "no activity logs yet": "لا توجد سجلات نشاط بعد",
  "resolve ticket": "حل التذكرة",
  "reopen ticket": "إعادة فتح التذكرة",
  "close ticket": "إغلاق التذكرة",
  "type your reply here...": "اكتب ردك هنا...",
  "high": "مرتفع",
  "medium": "متوسط",
  "low": "منخفض",
  "assign to lm staff": "تعيين لموظف",
  "designate a staff member to handle this ticket": "تخصيص موظف للتعامل مع هذه التذكرة",
  "-- select staff member --": "-- اختر موظفًا --",
  "assigned to admin": "معين للمسؤول",
  "message is required": "الرسالة مطلوبة",
  "failed to load ticket details.": "فشل تحميل تفاصيل التذكرة.",
  "superadmin": "مسؤول متميز",
  "super admin": "مسؤول متميز",
};

interface LanguageContextType {
  language: "en" | "ar";
  setLanguage: (lang: "en" | "ar") => Promise<void>;
  translateText: (text: string) => Promise<string>;
  t: (text: string) => string;
  addTranslations?: (newTranslations: Record<string, string>) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguageState] = useState<"en" | "ar">("en");
  const [cache, setCache] = useState<Record<string, string>>({});
  const [dynamicDictionary, setDynamicDictionary] = useState<Record<string, string>>({});
  const baseUrl = process.env.REACT_APP_BASE_URL || "";

  const profile = useSelector((state: any) => state?.auth?.profile);
  const dispatch = useDispatch();

  // Sync preferred language from profile when it loads
  useEffect(() => {
    if (profile?.preferredLanguage) {
      setLanguageState(profile.preferredLanguage);
    }
  }, [profile?.preferredLanguage]);

  // Set visual text direction and lang attribute on the HTML element
  useEffect(() => {
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [language]);

  const addTranslations = (newTranslations: Record<string, string>) => {
    setDynamicDictionary((prev) => ({
      ...prev,
      ...newTranslations,
    }));
  };

  const translateText = async (text: string): Promise<string> => {
    if (!text || typeof text !== "string" || !text.trim() || language === "en") return text;

    // Check local dictionary first
    const cleanText = text.trim().toLowerCase();
    if (LOCAL_DICTIONARY[cleanText]) return LOCAL_DICTIONARY[cleanText];
    const snakeText = cleanText.replace(/\s+/g, '_');
    if (LOCAL_DICTIONARY[snakeText]) return LOCAL_DICTIONARY[snakeText];
    const spaceText = cleanText.replace(/_+/g, ' ');
    if (LOCAL_DICTIONARY[spaceText]) return LOCAL_DICTIONARY[spaceText];

    if (dynamicDictionary[cleanText]) return dynamicDictionary[cleanText];

    // Check memory cache
    if (cache[text]) return cache[text];

    try {
      const res = await fetch4(`${baseUrl}/api/translate/translate`, {
        text,
        targetLang: language,
      });

      if (res?.success && res?.data?.translatedText) {
        const translated = res.data.translatedText;
        setCache((prev) => ({ ...prev, [text]: translated }));
        return translated;
      }
      return text;
    } catch (err) {
      console.error("AI Translation frontend error:", err);
      return text;
    }
  };

  const t = (text: string): string => {
    if (language === "en" || !text || typeof text !== "string") return text;
    const cleanText = text.trim().toLowerCase();
    if (LOCAL_DICTIONARY[cleanText]) {
      return LOCAL_DICTIONARY[cleanText];
    }
    const snakeText = cleanText.replace(/\s+/g, '_');
    if (LOCAL_DICTIONARY[snakeText]) {
      return LOCAL_DICTIONARY[snakeText];
    }
    const spaceText = cleanText.replace(/_+/g, ' ');
    if (LOCAL_DICTIONARY[spaceText]) {
      return LOCAL_DICTIONARY[spaceText];
    }
    if (dynamicDictionary[cleanText]) {
      return dynamicDictionary[cleanText];
    }
    if (cache[text]) return cache[text];
    return text;
  };

  const setLanguage = async (lang: "en" | "ar") => {
    setLanguageState(lang);
    try {
      if (profile) {
        dispatch(addProfileData({ ...profile, preferredLanguage: lang }));
      }
      await fetch5(`${baseUrl}/api/auth/language`, "PUT", { language: lang });
    } catch (err) {
      console.error("Failed to save language preference:", err);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translateText, t, addTranslations }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

// Helper component for in-place text translation
export function T({ children }: { children: any }) {
  const { language, translateText } = useLanguage();

  const getCleanText = (val: any): string => {
    if (Array.isArray(val)) {
      return val.map((item) => (typeof item === "string" ? item : "")).join("").trim();
    }
    if (typeof val === "string") {
      return val.trim();
    }
    return val ? String(val).trim() : "";
  };

  const textToTranslate = getCleanText(children);
  const [translated, setTranslated] = useState(textToTranslate);

  useEffect(() => {
    const text = getCleanText(children);
    if (language === "en") {
      setTranslated(text);
      return;
    }

    if (!text) {
      setTranslated("");
      return;
    }

    // Check dictionary synchronously first to prevent layout shift
    const cleanText = text.toLowerCase();
    if (LOCAL_DICTIONARY[cleanText]) {
      setTranslated(LOCAL_DICTIONARY[cleanText]);
      return;
    }
    const snakeText = cleanText.replace(/\s+/g, '_');
    if (LOCAL_DICTIONARY[snakeText]) {
      setTranslated(LOCAL_DICTIONARY[snakeText]);
      return;
    }
    const spaceText = cleanText.replace(/_+/g, ' ');
    if (LOCAL_DICTIONARY[spaceText]) {
      setTranslated(LOCAL_DICTIONARY[spaceText]);
      return;
    }
    if (cleanText === "—" || cleanText === "-") {
      setTranslated(text);
      return;
    }

    let active = true;
    translateText(text).then((res) => {
      if (active) setTranslated(res);
    });
    return () => {
      active = false;
    };
  }, [children, language, translateText]);

  return <>{translated}</>;
}

